(function(){
"use strict";

var MC_API   = "https://script.google.com/macros/s/AKfycbx4cDDEvk8YNl8_ObUtTyXL44ASWsO24yYbN4RUmPpSekq3eGhyuZGRQ4ieg8_DBoUq/exec";
var MC_TOKEN = "mc_cc6f126b6aaf46bfa553068c22727813";
var PAGE_CLIENTE = "/pages/cliente";
var PAGE_PEDIDO  = "/pages/pedido";
var PAGE_SIZE = 4;
var MAX_LINES = 7;
var MAX_RECENT_TPLS = 4;

var root = document.getElementById("mc-root");
function $(s){ return root.querySelector(s); }

/* ─── JSONP call ─── */
function call(params){
  return new Promise(function(res,rej){
    var cb = "mc_cb_"+Math.random().toString(36).slice(2)+"_"+Date.now();
    var s = document.createElement("script");
    var to = setTimeout(function(){ cl(); rej(new Error("timeout")); }, 30000);
    function cl(){
      clearTimeout(to);
      try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
      if(s.parentNode) s.parentNode.removeChild(s);
    }
    window[cb] = function(d){ cl(); res(d); };
    var qs = Object.keys(params).map(function(k){
      return encodeURIComponent(k)+"="+encodeURIComponent(params[k]);
    }).join("&");
    s.src = MC_API+"?key="+encodeURIComponent(MC_TOKEN)+"&callback="+cb+(qs?"&"+qs:"");
    s.onerror = function(){ cl(); rej(new Error("net")); };
    document.head.appendChild(s);
  });
}

/* ─── Formatters ─── */
var BRL = function(n){ return (Number(n)||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"}); };
var NUM = function(n){ return (Number(n)||0).toLocaleString("pt-BR"); };
var esc = function(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c];}); };

function parseDate(v){
  if(!v||v==="null"||v==="undefined") return null;
  var s = String(v).replace(" ","T").replace(/(\.\d{3})\d+/,"$1");
  var d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}
function relTime(v){
  var d=parseDate(v); if(!d) return "";
  var ms=Date.now()-d.getTime(); if(ms<0) return "agora";
  var m=Math.floor(ms/60000); if(m<60) return "há "+m+"min";
  var h=Math.floor(ms/3600000); if(h<24) return "há "+h+"h";
  var dy=Math.floor(ms/86400000); return "há "+dy+(dy===1?" dia":" dias");
}
function fmtDate(v){
  var d=parseDate(v); if(!d) return "";
  return d.toLocaleDateString("pt-BR");
}
function fmtDateTime(v){
  var d=parseDate(v); if(!d) return "";
  return d.toLocaleDateString("pt-BR")+", "+d.toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"});
}
function relDays(v){
  var d=parseDate(v); if(!d) return null;
  var ms=Date.now()-d.getTime(); if(ms<0) return "hoje";
  var dy=Math.floor(ms/86400000);
  if(dy===0) return "hoje";
  if(dy===1) return "há 1 dia";
  if(dy<60) return "há "+dy+" dias";
  return fmtDate(v);
}
/* Para carrinhos _naopago, o próprio pedido entra em ultima_compra.
   Retorna null se a data for igual ou posterior ao dia do carrinho. */
/* Para carrinhos _naopago, o próprio pedido conta em pedidos_ant.
   Desconta 1 para não exibir o pedido atual como histórico. */
function safePedidosAnt(c){
  var n=c.pedidos_ant||0;
  if(c._naopago) n=Math.max(0,n-1);
  return n;
}
/* Para _naopago, recorrente só vale se ainda sobrar pedido após descontar o atual */
function safeRecorrente(c){
  if(c._naopago) return safePedidosAnt(c)>0;
  return !!c.recorrente;
}

function safeUltimaCompra(c){
  var lp=parseDate(c.ultima_compra); if(!lp) return null;
  if(c._naopago){
    var ua=parseDate(c.updated_at);
    if(ua){
      var lpDay=lp.getFullYear()*10000+lp.getMonth()*100+lp.getDate();
      var uaDay=ua.getFullYear()*10000+ua.getMonth()*100+ua.getDate();
      if(lpDay>=uaDay) return null;
    }
  }
  return lp;
}

/* ─── WA SVG ─── */
var WA_SVG = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.137.563 4.143 1.535 5.878L.057 23.998l6.304-1.654A11.946 11.946 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.882a9.877 9.877 0 01-5.03-1.378l-.361-.214-3.741.981.998-3.648-.235-.374A9.868 9.868 0 012.118 12C2.118 6.618 6.618 2.118 12 2.118S21.882 6.618 21.882 12 17.382 21.882 12 21.882z"/></svg>';

/* ═══════════════════════════════════════
   PHONE FETCH FOR NAOPAGO CARTS
═══════════════════════════════════════ */
function _parsePhone(raw){
  var ph=String(raw||"").replace(/\D/g,"");
  if(ph.length===13&&ph.slice(0,2)==="55") ph=ph.slice(2); // strip DDI +55
  if(ph.length===12&&ph.slice(0,2)==="55") ph=ph.slice(2);
  if(ph.length===10) ph=ph.slice(0,2)+"9"+ph.slice(2);
  return ph.length===11?ph:"";
}
function _applyPhone(c,d){
  var obj=d&&(d.row||d.customer||d.data||d);
  var ph=_parsePhone(obj&&(obj.phone||obj.celular||obj.telefone));
  if(ph) c.phone=ph;
  return !!ph;
}
function fetchMissingPhones(carts, cb){
  /* inclui _naopago sem telefone, tendo customer_id OU email */
  var missing=carts.filter(function(c){
    if(!c._naopago) return false;
    if(_parsePhone(c.phone)) return false;
    return !!(c.customer_id||c.shopify_customer_id||c.client_id||c.user_id||c.clientId||c.email);
  });
  if(!missing.length){ cb(); return; }
  var pending=missing.length;
  function done(){ if(--pending===0) cb(); }
  missing.forEach(function(c){
    var custId=c.customer_id||c.shopify_customer_id||c.client_id||c.user_id||c.clientId;
    /* Fallback por email quando lookup por ID não achar telefone */
    function tryEmail(){
      var em=String(c.email||"").trim();
      if(!em){ console.log("[fetchPhone] sem ID nem email cid="+c.cart_id); done(); return; }
      call({resource:"customer_by_email",email:em}).then(function(d){
        if(!_applyPhone(c,d)) console.log("[fetchPhone] sem phone por email cid="+c.cart_id+" email="+em);
        done();
      }).catch(function(e){ console.log("[fetchPhone] email error",em,e); done(); });
    }
    if(!custId){ tryEmail(); return; }
    call({resource:"customer", id:custId}).then(function(d){
      if(!_applyPhone(c,d)) tryEmail(); /* ID não tinha phone, tenta email */
      else done();
    }).catch(function(e){ console.log("[fetchPhone] id error",custId,e); tryEmail(); });
  });
}

/* ═══════════════════════════════════════
   CART EXCLUDE
═══════════════════════════════════════ */
var _excludedCarts={};

function excludeCart(cid, cb){
  _excludedCarts[cid]=true;
  call({resource:"cart_exclude", cart_id:cid}).catch(function(){});
  if(cb) cb();
}

/* ═══════════════════════════════════════
   SERVER STATE: CONTACTS
═══════════════════════════════════════ */
var _contacts = {};

function loadContacts(cb){
  call({resource:"wa_contacts_list"}).then(function(d){
    if(d && d.contacts){
      _contacts = {};
      d.contacts.forEach(function(id){ _contacts[String(id)] = true; });
    }
    if(cb) cb();
  }).catch(function(){ if(cb) cb(); });
}

function isContacted(id){ return !!_contacts[String(id)]; }

function setContacted(id, val){
  if(val) _contacts[String(id)] = true;
  else delete _contacts[String(id)];
  call({resource:"wa_contact_save", cart_id:id, contacted:val?"1":"0"}).catch(function(){});
}

/* ═══════════════════════════════════════
   SERVER STATE: TEMPLATES
═══════════════════════════════════════ */
var _tpls = [];
var _activeTplId = "";
var _overflowSort = "recent";

function defaultTpls(){
  return [
    {id:"t_def1", name:"Modelo 1", lines:["Oi {nome}! Vimos que você deixou itens no carrinho aqui na Midnight Crew 🛒","O valor total é {valor}. Posso te ajudar a finalizar?","{link}"], send_count:0, conv_count:0, last_used:""},
    {id:"t_def2", name:"Modelo 2", lines:["Oi {nome}! Seu carrinho de {valor} ainda está esperando por você 💛","Qualquer dúvida, estou aqui!"], send_count:0, conv_count:0, last_used:""},
    {id:"t_def3", name:"Modelo 3", lines:["Oi {nome}! Notamos que você não finalizou seu pedido de {valor}.","Tem alguma dúvida? Posso ajudar 😊"], send_count:0, conv_count:0, last_used:""},
    {id:"t_def4", name:"Modelo 4", lines:["Oi {nome}! Você deixou um carrinho de {valor} conosco.","Quer aproveitar antes que esgote? Estou aqui!"], send_count:0, conv_count:0, last_used:""}
  ];
}

function loadTpls(cb){
  call({resource:"wa_tpl_list"}).then(function(d){
    if(d && d.templates && d.templates.length){
      _tpls = d.templates.map(function(t){
        if(typeof t.lines === "string"){
          try{ t.lines = JSON.parse(t.lines); }catch(e){ t.lines = [t.lines]; }
        }
        if(!Array.isArray(t.lines)||!t.lines.length) t.lines = [""];
        return t;
      });
    } else {
      _tpls = defaultTpls();
    }
    if(!_activeTplId || !findTpl(_activeTplId)) _activeTplId = _tpls[0] && _tpls[0].id;
    if(cb) cb();
  }).catch(function(){
    _tpls = defaultTpls();
    if(!_activeTplId) _activeTplId = _tpls[0] && _tpls[0].id;
    if(cb) cb();
  });
}

function findTpl(id){ return _tpls.filter(function(t){ return t.id===id; })[0]||null; }
function activeTpl(){ return findTpl(_activeTplId)||_tpls[0]||null; }

function sortedTpls(){
  var sorted = _tpls.slice();
  if(_overflowSort === "conv"){
    sorted.sort(function(a,b){
      var ra = a.send_count>0?a.conv_count/a.send_count:0;
      var rb = b.send_count>0?b.conv_count/b.send_count:0;
      return rb-ra;
    });
  } else {
    sorted.sort(function(a,b){
      var ta=a.last_used||a.created_at||"", tb=b.last_used||b.created_at||"";
      return tb>ta?1:tb<ta?-1:0;
    });
  }
  return sorted;
}

function saveTplToServer(tpl, cb){
  call({resource:"wa_tpl_save", id:tpl.id||"", name:tpl.name||"", lines:JSON.stringify(tpl.lines||[""])})
    .then(function(d){
      if(d && d.id && d.id!==tpl.id){ tpl.id=d.id; if(_activeTplId===tpl.id||!_activeTplId) _activeTplId=d.id; }
      if(cb) cb(d);
    }).catch(function(){ if(cb) cb(null); });
}

function deleteTplFromServer(id, cb){
  call({resource:"wa_tpl_del", id:id}).then(function(d){ if(cb)cb(d); }).catch(function(){ if(cb)cb(null); });
}

function genId(){ return "t"+Date.now().toString(36)+Math.random().toString(36).slice(2,5); }

/* ═══════════════════════════════════════
   MODAL
═══════════════════════════════════════ */
var modal = document.getElementById("ca-modal");
var modalPhone="", modalNome="", modalTotal=0, modalLink="", modalCid="";

function getModalLines(){
  var inputs = root.querySelectorAll(".ca-line-inp"), lines=[];
  inputs.forEach(function(inp){ lines.push(inp.value); });
  return lines;
}

function applyVar(text){
  return text
    .replace(/\{nome\}/g, String(modalNome||"").split(" ")[0])
    .replace(/\{valor\}/g, BRL(Number(modalTotal)||0))
    .replace(/\{link\}/g, modalLink||"");
}

function renderTplBar(){
  var sorted = sortedTpls();
  var recent = sorted.slice(0, MAX_RECENT_TPLS);
  var hasMore = sorted.length > MAX_RECENT_TPLS;
  var listEl = document.getElementById("ca-tpl-list");
  var moreBtn = document.getElementById("ca-tpl-more");
  if(!listEl) return;
  listEl.innerHTML = recent.map(function(t){
    var cr = t.send_count>0?Math.round(t.conv_count/t.send_count*100)+"%":"";
    return '<button class="'+(t.id===_activeTplId?"active":"")+'" data-tid="'+esc(t.id)+'">'
      +esc(t.name)+(cr?'<small style="opacity:.5;margin-left:5px">'+cr+'</small>':"")
    +'</button>';
  }).join("");
  if(moreBtn) moreBtn.style.display = hasMore?"":"none";
}

function renderOverflowList(){
  var el = document.getElementById("ca-tpl-overflow-list"); if(!el) return;
  var sorted = sortedTpls();
  el.innerHTML = sorted.map(function(t){
    var cr = t.send_count>0?(t.conv_count/t.send_count*100).toFixed(1)+"%":"—";
    return '<div class="ca-tpl-overflow-item'+(t.id===_activeTplId?" active":"")+'" data-tid="'+esc(t.id)+'">'
      +'<span class="ca-tpl-overflow-item-name">'+esc(t.name)+'</span>'
      +'<span class="ca-tpl-overflow-meta">'+cr+' conv · '+esc(t.send_count||0)+' envios</span>'
    +'</div>';
  }).join("");
}

function lineRowHtml(text, idx, total){
  return '<div class="ca-line-row" data-line-idx="'+idx+'">'
    +'<textarea class="ca-line-inp" rows="1" placeholder="Linha '+(idx+1)+'…">'+esc(text)+'</textarea>'
    +'<button class="ca-line-send" data-line-idx="'+idx+'" title="Enviar esta linha">'+WA_SVG+'</button>'
    +(total>1?'<button class="ca-line-rm" data-line-idx="'+idx+'" title="Remover">✕</button>':"")
  +'</div>';
}

function autoGrowAll(){
  root.querySelectorAll(".ca-line-inp").forEach(function(ta){
    ta.style.height="auto"; ta.style.height=Math.min(ta.scrollHeight,120)+"px";
  });
}

function renderModalLines(){
  var tpl=activeTpl(), lines=(tpl&&tpl.lines&&tpl.lines.length)?tpl.lines.slice():[""];
  var le=document.getElementById("ca-modal-lines"); if(!le) return;
  le.innerHTML=lines.map(function(l,i){ return lineRowHtml(l,i,lines.length); }).join("");
  autoGrowAll();
}

function applyTpl(id){
  _activeTplId=id;
  var tpl=findTpl(id)||_tpls[0]; if(!tpl) return;
  _activeTplId=tpl.id;
  var ni=document.getElementById("ca-modal-name-inp"); if(ni) ni.value=tpl.name;
  renderModalLines(); renderTplBar();
  var ov=document.getElementById("ca-tpl-overflow"); if(ov) ov.style.display="none";
}
function persistTplOnly(){
  if(!modalCid) return;
  var prev=_coupons[String(modalCid)]||{};
  var at=activeTpl();
  saveCoupon(modalCid, prev.coupon||"", prev.coupon_custom||"", at?String(at.name||""):"");
}

function openModal(phone, nome, total, link, cid){
  modalPhone=phone; modalNome=nome; modalTotal=total; modalLink=link||""; modalCid=cid||"";
  if(!_activeTplId||!findTpl(_activeTplId)) _activeTplId=_tpls[0]&&_tpls[0].id;
  document.getElementById("ca-modal-title").textContent="WhatsApp — "+nome;
  document.getElementById("ca-modal-sub").textContent=phone
    ?"("+phone.slice(0,2)+") "+phone.slice(2,7)+"-"+phone.slice(7):"Sem telefone";
  applyTpl(_activeTplId);
  renderTplBar();
  prefillCoupon();
  modal.style.display="flex";
  document.body.style.overflow="hidden";
}
function closeModal(){
  modal.style.display="none";
  document.body.style.overflow="";
  var ov=document.getElementById("ca-tpl-overflow"); if(ov) ov.style.display="none";
}

/* ── Cupom enviado (na janela de WhatsApp) ── */
function prefillCoupon(){
  var sel=document.getElementById("ca-coupon-sel"), cust=document.getElementById("ca-coupon-custom");
  if(!sel) return;
  var cp=_coupons[String(modalCid)]||{}, val=cp.coupon||"";
  if(val==="__custom__"||(val&&COUPON_OPTS.indexOf(val)<0)){
    sel.value="__custom__"; if(cust){ cust.style.display=""; cust.value=cp.coupon_custom||(val==="__custom__"?"":val); }
  } else {
    sel.value=val; if(cust){ cust.style.display="none"; cust.value=""; }
  }
  /* wiring idempotente: re-atribui a cada abertura do modal */
  sel.onchange=function(){
    if(cust) cust.style.display = sel.value==="__custom__" ? "" : "none";
    persistCoupon();
  };
  if(cust){ var _ct; cust.oninput=function(){ clearTimeout(_ct); _ct=setTimeout(persistCoupon,400); }; }
}
function currentCoupon(){
  var sel=document.getElementById("ca-coupon-sel"), cust=document.getElementById("ca-coupon-custom");
  if(!sel) return {coupon:"",custom:""};
  if(sel.value==="__custom__") return {coupon:"__custom__", custom:(cust?cust.value.trim():"")};
  return {coupon:sel.value, custom:""};
}
function persistCoupon(){
  if(!modalCid) return;
  var cc=currentCoupon();
  var at=activeTpl();
  saveCoupon(modalCid, cc.coupon, cc.custom, at?String(at.name||""):"");
}

/* ═══════════════════════════════════════
   DETAIL MODAL
═══════════════════════════════════════ */
var _detailModal = document.getElementById("ca-detail-modal");
var _dmBox = document.getElementById("ca-dm-box");
var _dmCurrentCid = "";

function _getNote(cid){ try{ return localStorage.getItem("mc_note_"+cid)||""; }catch(e){ return ""; } }
function _saveNote(cid,txt){ try{ localStorage.setItem("mc_note_"+cid,txt); }catch(e){} }

var _recovered={};
function loadRecovered(cb){
  call({resource:"wa_recovered_list"}).then(function(d){
    if(d && d.recovered){
      _recovered={};
      d.recovered.forEach(function(id){ _recovered[String(id)]=true; });
    } else {
      /* fallback: tenta localStorage */
      try{ var s=localStorage.getItem("mc_recovered_v1"); if(s)_recovered=JSON.parse(s); }catch(e){}
    }
    if(cb) cb();
  }).catch(function(){
    try{ var s=localStorage.getItem("mc_recovered_v1"); if(s)_recovered=JSON.parse(s); }catch(e){}
    if(cb) cb();
  });
}
function isRecovered(cid){
  if(_recovered[String(cid)]) return true;
  // conversões automáticas por cupom contam como recuperadas
  var c=(typeof allCarts!=="undefined"?allCarts:[]).filter(function(x){ return String(x.cart_id)===String(cid); })[0];
  return !!(c && String(c.auto_converted)==="1");
}
function setRecovered(cid,val){
  if(val)_recovered[String(cid)]=true; else delete _recovered[String(cid)];
  try{ localStorage.setItem("mc_recovered_v1",JSON.stringify(_recovered)); }catch(e){}
  call({resource:"wa_recovered_save", cart_id:cid, recovered:val?"1":"0"}).catch(function(){});
}

/* ── Convertido: override manual (tri-estado) sobre a detecção automática ── */
var _convertedOv={}; // cart_id -> "1" | "0"
function loadConverted(cb){
  call({resource:"wa_converted_list"}).then(function(d){ if(d && d.converted) _convertedOv=d.converted; if(cb)cb(); }).catch(function(){ if(cb)cb(); });
}
function setConverted(cid,val){
  _convertedOv[String(cid)]=val?"1":"0";
  call({resource:"wa_converted_save", cart_id:cid, converted:val?"1":"0"}).catch(function(){});
}
function isConvertedFinal(c){
  var ov=_convertedOv[String(c.cart_id)];
  if(ov==="1") return true; if(ov==="0") return false;
  if(String(c.auto_converted)==="1") return true; // cupom de carrinho usado / cupom enviado no WhatsApp
  return isConverted(c); // detecção automática (última compra > abandono)
}

/* cupons que qualificam um carrinho para a aba Convertidos.
   Base fixa (os já ativos) + cupons marcados como "carrinho" na página Cupons (config cupom_carrinho). */
var CONV_COUPONS_BASE=["CART10","10CART","CART15","15CART","MID20","FRETEFREE"];
function convCoupons(){
  var set={}; CONV_COUPONS_BASE.forEach(function(x){ set[String(x).trim().toUpperCase()]=1; });
  try{ var c=JSON.parse(localStorage.getItem("mc_gastos_cfg_v1")||"{}"); var arr=JSON.parse(c.cupom_carrinho||"[]"); if(Array.isArray(arr))arr.forEach(function(x){ var k=String(x||"").trim().toUpperCase(); if(k)set[k]=1; }); }catch(e){}
  return Object.keys(set);
}
function usedQualifyingCoupon(c){
  var codes=[c.cupom_usado, c.cupom].map(function(x){ return String(x||"").trim().toUpperCase(); });
  var qual=convCoupons();
  return qual.some(function(q){ return codes.indexOf(q)>=0; });
}
/* usou um cupom qualificador na compra = convertido (aba Convertidos) */
function qualifiesConverted(c){ return usedQualifyingCoupon(c); }

/* ── Convertidos direto dos PEDIDOS (mesma fonte da página de Pedidos) ──
   independe do backend gravar cupom_usado no carrinho */
var _convOrders=[];
function loadConvOrders(cb){
  call({resource:"orders",range:"max"}).then(function(d){
    var arr=(d&&(d.rows||d.data||d.orders))||[];
    var EXCL=["não pago","nao pago","cancelado","devolvido","estornado","reembolsado"];
    var qual=convCoupons();
    _convOrders=arr.filter(function(o){
      var code=String(o.cupom||"").trim().toUpperCase();
      if(qual.indexOf(code)<0) return false;
      return EXCL.indexOf(String(o.status||"").toLowerCase())<0;
    });
    if(cb)cb();
  }).catch(function(){ if(cb)cb(); });
}
/* pedidos com cupom → entradas de conversão, filtrados pelo período selecionado */
function convList(){
  var rw=rangeWindow(range);
  return _convOrders.filter(function(o){
    var oms=o.created_at?Date.parse(String(o.created_at).replace(" ","T")):0;
    if(rw.from!=null && oms && oms<rw.from) return false;
    if(rw.to!=null && oms && oms>rw.to) return false;
    return true;
  }).map(function(o){
    var code=String(o.cupom||"").toUpperCase();
    return { cart_id:"cp_"+(o.id||o.order_number), order_id:o.id||o.order_number, order_number:String(o.order_number||""),
      nome:o.customer_name||"—", customer_id:o.customer_id||"", total:Number(o.faturamento||0),
      cupom:code, cupom_usado:code, ultima_compra:o.created_at||"", updated_at:o.created_at||"",
      itens_qtd:Number(o.itens_qtd||1), utm_source:o.origem||"", campanha:o.campanha||"", etapa:"Cupom "+code, _cupom:true };
  });
}

/* ── Cupom enviado por carrinho ── */
var _coupons={}; // cart_id -> {coupon, coupon_custom, sent_at}
var COUPON_OPTS=["CART10","CART15","CART20","10CART","15CART","20CART","MID20","FRETEFREE"];
function loadCoupons(cb){
  call({resource:"wa_coupon_list"}).then(function(d){ if(d && d.coupons) _coupons=d.coupons; if(cb)cb(); }).catch(function(){ if(cb)cb(); });
}
function saveCoupon(cid, coupon, custom, tpl){
  var prev=_coupons[String(cid)]||{};
  var tplName=tpl!=null?tpl:(prev.tpl||"");
  _coupons[String(cid)]={coupon:coupon||"", coupon_custom:custom||"", tpl:tplName, sent_at:new Date().toISOString()};
  call({resource:"wa_coupon_save", cart_id:cid, coupon:coupon||"", coupon_custom:custom||"", tpl:tplName}).catch(function(){});
}

function openDetailModal(cid){
  var c=allCarts.filter(function(x){ return String(x.cart_id)===String(cid); })[0];
  if(!c) return;
  _dmCurrentCid=String(cid);

  var phone=String(c.phone||"").replace(/\D/g,"");
  var phoneDisplay=phone?"("+phone.slice(0,2)+") "+phone.slice(2,7)+"-"+phone.slice(7):"";
  var contacted=isContacted(cid);
  var recovered=isRecovered(cid);
  var converted=isConvertedFinal(c);
  var note=_getNote(cid);
  var profileHref=c.customer_id?PAGE_CLIENTE+"?id="+encodeURIComponent(c.customer_id):null;

  /* badges */
  var badges=[];
  if(c._naopago) badges.push('<span class="mc-ca-badge is-naopago">Não pago</span>');
  else if(safeRecorrente(c)) badges.push('<span class="mc-ca-badge is-rec">'+safePedidosAnt(c)+' ped. anteriores</span>');
  else badges.push('<span class="mc-ca-badge is-new">Novo cliente</span>');
  if(contacted) badges.push('<span class="mc-ca-badge" style="color:var(--good);border-color:var(--good)">Contatado</span>');
  if(converted) badges.push('<span class="mc-ca-badge" data-dm-converted="1" style="color:var(--good);border-color:var(--good)">Convertido</span>');

  /* products */
  var items=c.items||[];
  var totalItens=items.reduce(function(s,it){return s+(it.qty||1);},0);
  var itensRows=items.map(function(it){
    var unit=it.price!=null?it.price:(it.qty&&it.qty>0?it.total/it.qty:it.total);
    return '<tr>'
      +'<td class="dm-item-name">'+esc(it.name||"—")+'</td>'
      +'<td class="r" style="color:var(--mut)">\xd7'+esc(String(it.qty||1))+'</td>'
      +'<td class="r" style="color:var(--mut)">'+BRL(unit)+'</td>'
      +'<td class="r" style="color:var(--ink)">'+BRL(it.total||0)+'</td>'
    +'</tr>';
  }).join("");

  /* UTM / origem */
  var _origemVal=sourceInfo(c).label;
  var _sessaoRaw=String(c.utm_source_sessao||"").trim();
  var _sessaoVal=_sessaoRaw?normalizeOrigem(_sessaoRaw,c):"";
  var utmFields=[
    {lbl:"Origem",   val:_origemVal},
    {lbl:"Mídia",    val:c.utm_medium},
    {lbl:"Campanha", val:c.campanha||c.utm_campaign},
    {lbl:"Anúncio",  val:c.anuncio||c.utm_content},
    {lbl:"Sessão",   val:(_sessaoVal&&_sessaoVal!==_origemVal)?_sessaoVal:""},
    {lbl:"Etapa",    val:c.etapa}
  ];
  var utmHtml=utmFields.filter(function(r){return r.val;}).map(function(r){
    return '<div class="dm-row"><span class="dm-row-lbl">'+esc(r.lbl)+'</span><span class="dm-row-val">'+esc(r.val)+'</span></div>';
  }).join("")||'<span style="font-size:11px;color:var(--mut)">Sem dados de origem</span>';

  /* atividade */
  var actHtml=[
    {lbl:"Última compra", val:safeUltimaCompra(c)?fmtDate(c.ultima_compra)+" ("+relDays(c.ultima_compra)+")":"—"},
    c.order_number?{lbl:"Pedido",val:"#"+c.order_number}:null
  ].filter(Boolean).map(function(r){
    return '<div class="dm-row"><span class="dm-row-lbl">'+esc(r.lbl)+'</span><span class="dm-row-val">'+esc(r.val)+'</span></div>';
  }).join("");

  /* build */
  var html=
    '<div class="dm-head">'
      +'<div class="dm-head-info">'
        +(profileHref
          ?'<a class="dm-head-name" href="'+esc(profileHref)+'">'+esc(c.nome||"—")+'</a>'
          :'<span class="dm-head-name">'+esc(c.nome||"—")+'</span>')
        +'<div class="dm-head-meta">'
          +(phoneDisplay
            ?'<button class="dm-head-phone" id="ca-dm-head-phone">'
              +'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.42 2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.6a16 16 0 0 0 6 6l.92-.92a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>'
              +esc(phoneDisplay)+'</button>':"")
          +'<span class="dm-head-time">'+esc(relTime(c.updated_at)||"—")+'</span>'
        +'</div>'
        +'<div class="dm-head-badges">'+badges.join("")+'</div>'
      +'</div>'
      +'<button class="dm-close" id="ca-dm-close">✕</button>'
    +'</div>'
    +'<div class="dm-body">'
      +'<div class="dm-kpis">'
        +'<div class="dm-kpi"><span class="dm-kpi-ic"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg></span><div class="dm-kpi-lbl">Valor</div><div class="dm-kpi-val" style="color:var(--acc)">'+BRL(c.total)+'</div></div>'
        +'<div class="dm-kpi"><span class="dm-kpi-ic"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg></span><div class="dm-kpi-lbl">Itens</div><div class="dm-kpi-val">'+NUM(totalItens)+'</div></div>'
        +'<div class="dm-kpi"><span class="dm-kpi-ic"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg></span><div class="dm-kpi-lbl">Pedidos</div><div class="dm-kpi-val">'+NUM(c.pedidos_ant||0)+'</div></div>'
        +'<div class="dm-kpi ca-hide-m"><div class="dm-kpi-lbl">Total gasto</div><div class="dm-kpi-val">'+(c.valor_gasto?BRL(c.valor_gasto):"—")+'</div></div>'
        +'<div class="dm-kpi ca-hide-m"><div class="dm-kpi-lbl">Ticket médio</div><div class="dm-kpi-val">'+(c.ticket_hist?BRL(c.ticket_hist):"—")+'</div></div>'
      +'</div>'
      +'<div class="dm-cols">'
        +'<div class="dm-section">'
          +'<div class="dm-section-title">Produtos do carrinho</div>'
          +'<table class="dm-items-table"><thead><tr>'
            +'<th>Produto</th><th class="r">Qtd</th><th class="r">Unit.</th><th class="r">Total</th>'
          +'</tr></thead><tbody>'+itensRows+'</tbody></table>'
        +'</div>'
        +'<div style="display:flex;flex-direction:column;gap:16px">'
          +'<div class="dm-section"><div class="dm-section-title">Origem do cliente</div>'+utmHtml+'</div>'
          +'<div class="dm-section"><div class="dm-section-title">Atividade</div>'+actHtml+'</div>'
        +'</div>'
      +'</div>'
      +'<div class="dm-notes-wrap">'
        +'<div class="dm-section-title">Observações internas</div>'
        +'<textarea class="dm-notes-ta" id="ca-dm-note" placeholder="Anotações sobre este carrinho…">'+esc(note)+'</textarea>'
      +'</div>'
    +'</div>'
    +'<div class="dm-actions">'
      +(phone?'<button class="dm-btn is-wa" id="ca-dm-wa" aria-label="WhatsApp">'+WA_SVG+'<span class="dm-wa-txt">WhatsApp</span></button>':"")
      +(c.purchase_url?'<a class="dm-btn" href="'+esc(c.purchase_url)+'" target="_blank" rel="noopener">Abrir checkout</a>':"")
      +'<button class="dm-btn'+(contacted?" is-on":"")+'" id="ca-dm-cont"><span class="dm-chk">'+(contacted?"✓":"")+'</span>Contatado</button>'
      +'<button class="dm-btn'+(converted?" is-on":"")+'" id="ca-dm-conv"><span class="dm-chk">'+(converted?"✓":"")+'</span>Convertido</button>'
      +'<button class="dm-btn dm-btn-del" id="ca-dm-del">Excluir</button>'
    +'</div>';

  _dmBox.innerHTML=html;
  _detailModal.style.display="flex";
  document.body.style.overflow="hidden";

  /* inner actions */
  var dmClose=document.getElementById("ca-dm-close");
  if(dmClose) dmClose.addEventListener("click",closeDetailModal);

  /* telefone no header → fecha detail, abre template WA */
  var dmHeadPhone=document.getElementById("ca-dm-head-phone");
  if(dmHeadPhone) dmHeadPhone.addEventListener("click",function(){
    closeDetailModal();
    openModal(phone,c.nome||"",c.total,c.purchase_url||"",cid);
  });

  /* botão WA no footer → fecha detail, abre template WA */
  var dmWa=document.getElementById("ca-dm-wa");
  if(dmWa) dmWa.addEventListener("click",function(){
    closeDetailModal();
    openModal(phone,c.nome||"",c.total,c.purchase_url||"",cid);
  });

  var dmCont=document.getElementById("ca-dm-cont");
  if(dmCont) dmCont.addEventListener("click",function(){
    var now=!isContacted(cid);
    setContacted(cid,now);
    var chk=this.querySelector(".dm-chk"); if(chk) chk.textContent=now?"✓":"";
    this.classList.toggle("is-on",now);
    _refreshCard(cid);
    /* atualizar badge no modal */
    var badgeEl=_dmBox.querySelector('.dm-head-badges');
    if(badgeEl){
      var span=badgeEl.querySelector('[data-dm-contacted]');
      if(now&&!span){ var s=document.createElement('span'); s.className='mc-ca-badge'; s.style.cssText='color:var(--good);border-color:var(--good)'; s.textContent='Contatado'; s.setAttribute('data-dm-contacted','1'); badgeEl.appendChild(s); }
      else if(!now&&span) span.remove();
    }
  });

  var dmRec=document.getElementById("ca-dm-rec");
  if(dmRec) dmRec.addEventListener("click",function(){
    var now=!isRecovered(cid);
    setRecovered(cid,now);
    var chk2=this.querySelector(".dm-chk"); if(chk2) chk2.textContent=now?"✓":"";
    this.classList.toggle("is-rec",now);
    var badgeEl=_dmBox.querySelector('.dm-head-badges');
    if(badgeEl){
      var span=badgeEl.querySelector('[data-dm-recovered]');
      if(now&&!span){ var s=document.createElement('span'); s.className='mc-ca-badge'; s.style.cssText='color:var(--acc);border-color:rgba(255,242,0,.5)'; s.textContent='Recuperado'; s.setAttribute('data-dm-recovered','1'); badgeEl.appendChild(s); }
      else if(!now&&span) span.remove();
    }
  });

  var dmConv=document.getElementById("ca-dm-conv");
  if(dmConv) dmConv.addEventListener("click",function(){
    var now=!isConvertedFinal(c);
    setConverted(cid,now);
    var chk3=this.querySelector(".dm-chk"); if(chk3) chk3.textContent=now?"✓":"";
    this.classList.toggle("is-on",now);
    _refreshCard(cid);
    var badgeEl=_dmBox.querySelector('.dm-head-badges');
    if(badgeEl){
      var span=badgeEl.querySelector('[data-dm-converted]');
      if(now&&!span){ var s=document.createElement('span'); s.className='mc-ca-badge'; s.style.cssText='color:var(--good);border-color:var(--good)'; s.textContent='Convertido'; s.setAttribute('data-dm-converted','1'); badgeEl.appendChild(s); }
      else if(!now&&span) span.remove();
    }
  });

  var dmDel=document.getElementById("ca-dm-del");
  if(dmDel) dmDel.addEventListener("click",function(){
    if(!confirm("Excluir este carrinho da base? Ele não voltará em futuros resyncs.")) return;
    excludeCart(cid,function(){
      allCarts=allCarts.filter(function(x){ return String(x.cart_id)!==String(cid); });
      closeDetailModal();
      render();
    });
  });

  var dmNote=document.getElementById("ca-dm-note");
  if(dmNote) dmNote.addEventListener("blur",function(){ _saveNote(cid,this.value); });
}

function closeDetailModal(){
  var ta=document.getElementById("ca-dm-note");
  if(ta&&_dmCurrentCid) _saveNote(_dmCurrentCid,ta.value);
  _detailModal.style.display="none";
  document.body.style.overflow="";
}

/* backdrop click */
document.getElementById("ca-dm-bd").addEventListener("click",closeDetailModal);

/* card click → open detail / nav buttons */
root.addEventListener("click",function(ev){
  var navBtn=ev.target.closest("[data-cardir]");
  if(navBtn){carouselStep(Number(navBtn.dataset.cardir));return;}
  if(ev.target.closest(".mc-ca-btn-wa")) return;
  if(ev.target.closest(".mc-ca-cont-chk")) return;
  if(ev.target.closest(".mc-ca-del-btn")) return;
  if(ev.target.closest("a")) return;
  var row=ev.target.closest(".mc-ca-row");
  if(row){ openDetailModal(row.dataset.cid); return; }
  var card=ev.target.closest(".mc-ca-card");
  if(card) openDetailModal(card.dataset.cid);
});

/* ─── Modal events ─── */
root.addEventListener("click",function(ev){
  /* template bar */
  var tBtn=ev.target.closest("#ca-tpl-list [data-tid]");
  if(tBtn){ applyTpl(tBtn.dataset.tid); persistTplOnly(); return; }

  /* overflow item */
  var ovItem=ev.target.closest(".ca-tpl-overflow-item[data-tid]");
  if(ovItem){ applyTpl(ovItem.dataset.tid); persistTplOnly(); return; }

  /* overflow sort */
  var sortBtn=ev.target.closest(".ca-tpl-overflow-sort button");
  if(sortBtn){
    _overflowSort=sortBtn.dataset.sort;
    root.querySelectorAll(".ca-tpl-overflow-sort button").forEach(function(b){ b.classList.toggle("active",b===sortBtn); });
    renderOverflowList(); return;
  }

  /* new template */
  if(ev.target.closest("#ca-tpl-new")){
    var novo={id:genId(),name:"Novo modelo",lines:[""],send_count:0,conv_count:0,last_used:""};
    _tpls.push(novo);
    applyTpl(novo.id);
    saveTplToServer(novo,null);
    var ni=document.getElementById("ca-modal-name-inp"); if(ni){ni.focus();ni.select();}
    return;
  }

  /* toggle overflow */
  if(ev.target.closest("#ca-tpl-more")){
    var ov=document.getElementById("ca-tpl-overflow");
    if(ov){ var show=ov.style.display==="none"; ov.style.display=show?"":"none"; if(show) renderOverflowList(); }
    return;
  }

  /* close overflow */
  if(ev.target.closest("#ca-tpl-overflow-close")){
    var ov2=document.getElementById("ca-tpl-overflow"); if(ov2) ov2.style.display="none"; return;
  }

  /* delete template */
  if(ev.target.closest("#ca-tpl-del")){
    if(_tpls.length<=1){ alert("Mantenha ao menos um modelo."); return; }
    var delId=_activeTplId;
    _tpls=_tpls.filter(function(t){ return t.id!==delId; });
    deleteTplFromServer(delId,null);
    _activeTplId=_tpls[0]&&_tpls[0].id;
    applyTpl(_activeTplId); return;
  }

  /* inserir variável no input focado */
  var varBtn=ev.target.closest(".ca-var-btn");
  if(varBtn){
    var varText=varBtn.dataset.var||"";
    /* pega o último input de linha focado, ou o primeiro disponível */
    var focused=document.activeElement;
    var target=focused&&focused.classList.contains("ca-line-inp")?focused:root.querySelector(".ca-line-inp");
    if(target){
      var ss=target.selectionStart, se=target.selectionEnd, v=target.value;
      target.value=v.slice(0,ss)+varText+v.slice(se);
      target.selectionStart=target.selectionEnd=ss+varText.length;
      target.focus();
      target.dispatchEvent(new Event("input"));
    }
    return;
  }

  /* add line */
  if(ev.target.closest("#ca-add-line")){
    var lines=getModalLines(); if(lines.length>=MAX_LINES) return;
    lines.push("");
    var le=document.getElementById("ca-modal-lines");
    if(le){ le.innerHTML=lines.map(function(l,i){ return lineRowHtml(l,i,lines.length); }).join(""); autoGrowAll(); }
    var last=le&&le.querySelector(".ca-line-row:last-child .ca-line-inp"); if(last) last.focus();
    return;
  }

  /* remove line */
  var rmBtn=ev.target.closest(".ca-line-rm");
  if(rmBtn){
    var lines2=getModalLines(), idx=parseInt(rmBtn.dataset.lineIdx,10);
    if(lines2.length<=1) return;
    lines2.splice(idx,1);
    var le2=document.getElementById("ca-modal-lines");
    if(le2){ le2.innerHTML=lines2.map(function(l,i){ return lineRowHtml(l,i,lines2.length); }).join(""); autoGrowAll(); }
    return;
  }

  /* send individual line */
  var sendBtn=ev.target.closest(".ca-line-send");
  if(sendBtn){
    if(!modalPhone){ alert("Sem número de telefone para este cliente."); return; }
    var idx2=parseInt(sendBtn.dataset.lineIdx,10);
    var inputs=root.querySelectorAll(".ca-line-inp");
    var text=inputs[idx2]?inputs[idx2].value:"";
    var msg=applyVar(text);
    if(!msg.trim()){ alert("Linha vazia."); return; }
    window.open("https://wa.me/55"+modalPhone+"?text="+encodeURIComponent(msg),"_blank","noopener");
    persistCoupon(); // registra no banco o cupom enviado neste contato
    if(modalCid && !isContacted(modalCid)){
      setContacted(modalCid,true);
      var at=activeTpl();
      if(at){ at.send_count=(at.send_count||0)+1; at.last_used=new Date().toISOString(); }
      _refreshCard(modalCid);
      render(); // move o carrinho de "Abandonados" para "Contatados"
    }
    return;
  }

  /* save template */
  if(ev.target.closest("#ca-modal-save")){
    var tpl3=activeTpl(); if(!tpl3) return;
    var ni2=document.getElementById("ca-modal-name-inp");
    tpl3.name=(ni2&&ni2.value.trim())||tpl3.name;
    tpl3.lines=getModalLines();
    saveTplToServer(tpl3,function(){
      renderTplBar();
      var sb=document.getElementById("ca-modal-save");
      if(sb){ var orig=sb.textContent; sb.textContent="Salvo ✓"; setTimeout(function(){ sb.textContent=orig; },1400); }
    });
    return;
  }

  /* close modal */
  if(ev.target.closest("#ca-modal-close")||ev.target.id==="ca-modal-bd"){ closeModal(); return; }

  /* excluir carrinho da base */
  var delBtn=ev.target.closest(".mc-ca-del-btn");
  if(delBtn){
    var dcid=delBtn.getAttribute("data-cid");
    if(!confirm("Excluir este carrinho da base? Ele não voltará em futuros resyncs.")) return;
    var dcard=root.querySelector('.mc-ca-card[data-cid="'+dcid+'"]');
    if(dcard){ dcard.classList.add("is-animating","mc-slide-out"); }
    setTimeout(function(){
      excludeCart(dcid,function(){
        allCarts=allCarts.filter(function(c){return String(c.cart_id)!==dcid;});
        currentPage=1; render();
      });
    },280);
    return;
  }

  /* WhatsApp: abre o redirecionamento direto (sem janela de mensagem) */
  var waBtn=ev.target.closest(".mc-ca-btn-wa");
  if(waBtn){ ev.preventDefault();
    var phone=String(waBtn.dataset.phone||"").replace(/\D/g,"");
    var nome=String(waBtn.dataset.nome||""), total=Number(waBtn.dataset.total||0), link=String(waBtn.dataset.link||""), cid=String(waBtn.dataset.cid||"");
    var tpl=activeTpl();
    var msg=(tpl&&tpl.lines?tpl.lines.join("\n"):"")
      .replace(/\{nome\}/g, nome.split(" ")[0])
      .replace(/\{valor\}/g, BRL(total))
      .replace(/\{link\}/g, link);
    var url="https://wa.me/"+(phone?("55"+phone):"")+(msg.trim()?("?text="+encodeURIComponent(msg)):"");
    window.open(url,"_blank","noopener");
    if(cid && !isContacted(cid)){ setContacted(cid,true); render(); } // marca contatado e move de aba
    return;
  }

  /* toggle contacted */
  var contBtn=ev.target.closest(".mc-ca-cont-chk");
  if(contBtn){
    var cid=contBtn.getAttribute("data-cid");
    var card=root.querySelector('.mc-ca-card[data-cid="'+cid+'"]');
    if(card&&!card.classList.contains("is-animating")){
      card.classList.add("is-animating","mc-slide-out");
      setTimeout(function(){
        setContacted(cid,!isContacted(cid));
        currentPage=1; renderCards(filtered());
      },300);
    }
    return;
  }
});

root.addEventListener("input",function(ev){
  if(ev.target.classList.contains("ca-line-inp")){
    ev.target.style.height="auto";
    ev.target.style.height=Math.min(ev.target.scrollHeight,120)+"px";
  }
});

document.addEventListener("keydown",function(e){
  if(e.key==="Escape"){
    if(_detailModal&&_detailModal.style.display!=="none"){ closeDetailModal(); return; }
    if(modal&&modal.style.display!=="none") closeModal();
    return;
  }
  var modalsOpen=(_detailModal&&_detailModal.style.display!=="none")||(modal&&modal.style.display!=="none");
  if(!modalsOpen){
    if(e.key==="ArrowLeft"){carouselStep(-1);e.preventDefault();}
    else if(e.key==="ArrowRight"){carouselStep(1);e.preventDefault();}
  }
});

/* toque para paginar (sem sequestrar o scroll do mouse na grade flat) */
(function(){
  var wrap=document.querySelector(".mc-ca-carousel-wrap");
  if(!wrap) return;
  var _tx=0,_ty=0;
  wrap.addEventListener("touchstart",function(e){ _tx=e.touches[0].clientX; _ty=e.touches[0].clientY; },{passive:true});
  wrap.addEventListener("touchend",function(e){
    var dx=e.changedTouches[0].clientX-_tx, dy=e.changedTouches[0].clientY-_ty;
    if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)) carouselStep(dx<0?1:-1);
  },{passive:true});
})();

function _refreshCard(cid){
  renderCards(filtered());
}

/* ═══════════════════════════════════════
   CARD BUILDER
═══════════════════════════════════════ */
function normalizeOrigem(raw, c){
  var v=String(raw||"").trim();
  if(!v) return "";
  var low=v.toLowerCase().replace(/â/g,"a").replace(/ã/g,"a").replace(/ê/g,"e");
  // Specific mappings
  if(low==="ig"||low==="instagram") return "Instagram";
  if(low.indexOf("whatsapp")!==-1) return "Whatsapp";
  if(low==="organico") return "Orgânico";
  if(low==="planilha"){
    // Para não pago, usar origem do pedido original
    if(c&&c._naopago){
      var alt=String(c.utm_source_sessao||c.origem_pedido||"").trim();
      if(alt&&alt.toLowerCase()!=="planilha") return normalizeOrigem(alt,null);
    }
    return "Planilha";
  }
  if(low==="trafego") return "Tráfego";
  // Default: capitalize first letter
  return v.charAt(0).toUpperCase()+v.slice(1);
}

function iconForSource(si){
  var w='<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">';
  var lbl=String(si&&si.label||'').toLowerCase(), cls=String(si&&si.cls||'');
  if(cls==='is-paid'||/(instagram|facebook|tráfego|trafego|meta)/.test(lbl)) return w+'<rect x="2" y="2" width="20" height="20" rx="5"></rect><circle cx="12" cy="12" r="4"></circle><circle cx="17.5" cy="6.5" r="1"></circle></svg>'; // instagram/pago
  if(cls==='is-inf'||/influen/.test(lbl)) return w+'<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>'; // influencer
  return w+'<circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>'; // orgânico/outros
}
function sourceInfo(c){
  var src=String(c.utm_source||"").toLowerCase();
  var med=String(c.utm_medium||"").toLowerCase();
  if(!src&&!med) return {label:"Orgânico",cls:""};
  if(/(influencer|creator|collab)/i.test(src+med)) return {label:"Influencer",cls:"is-inf"};
  if(/(facebook|instagram|fb|meta)/i.test(src)) return {label:"Tráfego pago",cls:"is-paid"};
  var raw=src||med;
  return {label:normalizeOrigem(raw,c),cls:""};
}

function buildCardInner(c){
  var cid=String(c.cart_id||"");
  var contacted=isContacted(cid);
  var phone=String(c.phone||"").replace(/\D/g,"");
  var phoneDisplay=phone?"("+phone.slice(0,2)+") "+phone.slice(2,7)+"-"+phone.slice(7):"";
  var time=relTime(c.updated_at)||"—";
  var _ulp=safeUltimaCompra(c); var ultimaCompra=_ulp?relDays(c.ultima_compra):null;
  var profileHref=c.customer_id?PAGE_CLIENTE+"?id="+encodeURIComponent(c.customer_id):null;

  var recBadge=c._naopago
    ?'<span class="mc-ca-badge is-naopago">Não pago</span>'
    :safeRecorrente(c)
      ?'<span class="mc-ca-badge is-rec">'+(c.pedidos_ant||0)+" ped. anteriores</span>"
      :'<span class="mc-ca-badge is-new">Novo cliente</span>';

  var nameEl=profileHref
    ?'<a class="mc-ca-name" href="'+esc(profileHref)+'">'+esc(c.nome||"—")+'</a>'
    :'<span class="mc-ca-name">'+esc(c.nome||"—")+'</span>';

  var items=c.items||[];
  var itensHtml=items.slice(0,4).map(function(it){
    return '<div class="mc-ca-item">'
      +'<span class="mc-ca-item-name">'+esc(it.name||"—")+'</span>'
      +'<span class="mc-ca-item-qty">\xd7'+(it.qty||1)+'</span>'
      +'<span class="mc-ca-item-price">'+BRL(it.total||0)+'</span>'
    +'</div>';
  }).join("");
  if(items.length>4){ var r=items.length-4; itensHtml+='<div class="mc-ca-item"><span class="mc-ca-item-name">+'+r+' produto'+(r>1?"s":"")+'</span></div>'; }

  var histHtml="";
  if(safeRecorrente(c)){
    histHtml='<div class="mc-ca-hist">'
      +'<div class="mc-ca-hist-cell"><div class="mc-ca-hist-lbl">Pedidos</div><div class="mc-ca-hist-val">'+NUM(c.pedidos_ant||0)+'</div></div>'
      +'<div class="mc-ca-hist-cell"><div class="mc-ca-hist-lbl">Gasto total</div><div class="mc-ca-hist-val">'+(c.valor_gasto?BRL(c.valor_gasto):"—")+'</div></div>'
      +'<div class="mc-ca-hist-cell"><div class="mc-ca-hist-lbl">Ticket médio</div><div class="mc-ca-hist-val">'+(c.ticket_hist?BRL(c.ticket_hist):"—")+'</div></div>'
    +'</div>';
  }

  var chkHtml='<button class="mc-ca-cont-chk'+(contacted?" is-contacted":"")+'" data-cid="'+esc(cid)+'">'
    +'Contatado <span class="chk-box"><svg viewBox="0 0 10 10" fill="currentColor"><path d="M1.5 5L4 7.5 8.5 2.5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></span>'
  +'</button>';

  return '<div class="mc-ca-badges" style="justify-content:space-between;align-items:center">'
      +'<div style="display:flex;gap:6px;flex-wrap:wrap">'+recBadge+'</div>'+chkHtml
    +'</div>'
    +'<div class="mc-ca-name-row">'+nameEl+'<span class="mc-ca-time">'+esc(time)+'</span></div>'
    +(c.email?'<div class="mc-ca-meta-row"><span class="mc-ca-meta">'+esc(c.email)+'</span></div>':"")
    +(phoneDisplay?'<div class="mc-ca-phone mc-ca-btn-wa" style="color:var(--acc);cursor:pointer;font-size:11px" data-phone="'+esc(phone)+'" data-nome="'+esc(c.nome||"")+'" data-total="'+esc(String(c.total||0))+'" data-link="'+esc(c.purchase_url||"")+'" data-cid="'+esc(cid)+'">'+esc(phoneDisplay)+'</div>':"")
    +(ultimaCompra?'<div class="mc-ca-last">Último pedido <span>'+ultimaCompra+'</span></div>':'<div class="mc-ca-last" style="color:var(--mut)">Nenhum pedido registrado</div>')
    +'<div class="mc-ca-valor-row">'
      +'<div class="mc-ca-valor"><span class="mc-ca-valor-num">'+BRL(c.total)+'</span><span class="mc-ca-valor-lbl">abandonado</span></div>'
    +'</div>'
    +'<div class="mc-ca-items">'+itensHtml+'</div>'
    +histHtml
    +'<div class="mc-ca-del-row"><button class="mc-ca-del-btn" data-cid="'+esc(cid)+'">excluir da base</button></div>';
}

function buildCard(c){
  var cid=String(c.cart_id||"");
  var contacted=isContacted(cid);
  return '<div class="mc-ca-card'+(contacted&&_tab!=="contatados"?" is-contacted":"")+'" data-cid="'+esc(cid)+'">'
    +buildCardInner(c)
  +'</div>';
}

/* ═══════════════════════════════════════
   LISTA DE CARRINHOS (tabela)
═══════════════════════════════════════ */
var CART_COLS=[
  {k:"nome",       label:"Cliente",   t:"name"},
  {k:"status",     label:"Status",    t:"status"},
  {k:"utm_source", label:"Origem",    t:"canal"},
  {k:"phone",      label:"Telefone",  t:"phone"},
  {k:"itens_qtd",  label:"Itens",     t:"itens"},
  {k:"total",      label:"Valor",     t:"brl"},
  {k:"updated_at", label:"Quando",    t:"dt"},
  {k:"contatado",  label:"Contato",   t:"cont"}
];
var _cartSort={k:"updated_at",dir:-1};

function statusRank(c){ return c._naopago?2:(safeRecorrente(c)?1:0); }

function cartCell(col,c){
  var contacted=isContacted(String(c.cart_id));
  switch(col.t){
    case"name":
      return '<td class="mc-ca-row-name">'+esc(c.nome||"—")+'</td>';
    case"status":
      var badge=c._naopago
        ?'<span class="mc-ca-badge is-naopago">Não pago</span>'
        :safeRecorrente(c)
          ?'<span class="mc-ca-badge is-rec">'+safePedidosAnt(c)+' ped.</span>'
          :'<span class="mc-ca-badge is-new">Novo</span>';
      return '<td>'+badge+'</td>';
    case"canal":
      var src=sourceInfo(c);
      return '<td><span class="mc-ca-origem '+src.cls+'">'+esc(src.label)+'</span></td>';
    case"phone":
      var ph=String(c.phone||"").replace(/\D/g,"");
      var pd=ph?"("+ph.slice(0,2)+") "+ph.slice(2,7)+"-"+ph.slice(7):"—";
      return '<td style="color:var(--mut);font-size:11px">'+esc(pd)+'</td>';
    case"itens":
      var items=c.items||[];
      var n=items.reduce(function(s,it){return s+(it.qty||1);},0);
      var arr=items.map(function(i){return (i.name||i.title||"Item")+" \xd7"+(i.qty||1);});
      return '<td><span class="mc-conv-items" data-items="'+esc(arr.join("||"))+'">'+(n?n+" item"+(n!==1?"s":""):"—")+'</span></td>';
    case"brl":
      return '<td class="r" style="font-weight:700;color:var(--acc)">'+BRL(c.total)+'</td>';
    case"dt":
      return '<td style="color:var(--mut);font-size:11px">'+esc(relTime(c.updated_at)||"—")+'</td>';
    case"cont":
      return '<td style="text-align:center">'+(contacted
        ?'<span class="mc-ca-row-chk">✓</span>'
        :'<span style="color:var(--mut)">—</span>')+'</td>';
    default:
      return '<td>—</td>';
  }
}

var _listPage=1, LIST_PER_PAGE=15;
function renderCartList(list){
  var grid=$("#ca-grid");
  if(!list.length){
    grid.innerHTML='<p class="mc-empty">Nenhum carrinho encontrado.</p>';
    return;
  }
  var sorted=list.slice().sort(function(a,b){
    var k=_cartSort.k,dir=_cartSort.dir;
    if(k==="updated_at"){var da=parseDate(a.updated_at)||new Date(0),db=parseDate(b.updated_at)||new Date(0);return dir*(da-db);}
    if(k==="total"){return dir*((Number(a.total)||0)-(Number(b.total)||0));}
    if(k==="itens_qtd"){var na=(a.items||[]).reduce(function(s,it){return s+(it.qty||1);},0),nb=(b.items||[]).reduce(function(s,it){return s+(it.qty||1);},0);return dir*(na-nb);}
    if(k==="status"){return dir*(statusRank(a)-statusRank(b));}
    if(k==="contatado"){return dir*((isContacted(String(a.cart_id))?1:0)-(isContacted(String(b.cart_id))?1:0));}
    if(k==="utm_source"){return dir*String(sourceInfo(a).label).localeCompare(String(sourceInfo(b).label));}
    return dir*String(a[k]||"").localeCompare(String(b[k]||""));
  });

  function arrow(k){return _cartSort.k===k?(_cartSort.dir===1?" ↑":" ↓"):" ";}
  var thead='<tr>'+CART_COLS.map(function(col){
    var r=(col.t==="brl")?' class="r"':'';
    return '<th'+r+' data-ctk="'+esc(col.k)+'" style="cursor:pointer;user-select:none">'+esc(col.label)
      +'<span style="color:var(--acc);font-size:9px">'+arrow(col.k)+'</span></th>';
  }).join('')+'</tr>';

  /* paginação: 15 por página */
  var totalPages=Math.max(1,Math.ceil(sorted.length/LIST_PER_PAGE));
  if(_listPage>totalPages) _listPage=totalPages;
  if(_listPage<1) _listPage=1;
  var start=(_listPage-1)*LIST_PER_PAGE;
  var pageRows=sorted.slice(start,start+LIST_PER_PAGE);

  var isMobile = (window.matchMedia && window.matchMedia('(max-width:600px)').matches) || window.innerWidth<=600;
  var tbody=pageRows.map(function(c){
    var cid=String(c.cart_id||"");
    var contacted=isContacted(cid);
    return '<tr class="mc-ca-row'+(contacted&&_tab!=="contatados"?" is-contacted":"")+'" data-cid="'+esc(cid)+'">'
      +CART_COLS.map(function(col){return cartCell(col,c);}).join('')
    +'</tr>';
  }).join('');

  var pager='';
  if(totalPages>1){
    var from=start+1, to=Math.min(start+LIST_PER_PAGE,sorted.length);
    pager='<div class="mc-ca-pager">'
      +'<button class="mc-ca-pg-btn" data-pg="prev"'+(_listPage<=1?' disabled':'')+'>‹ Anterior</button>'
      +'<span class="mc-ca-pg-info">'+from+'–'+to+' de '+sorted.length+' · pág. '+_listPage+'/'+totalPages+'</span>'
      +'<button class="mc-ca-pg-btn" data-pg="next"'+(_listPage>=totalPages?' disabled':'')+'>Próxima ›</button>'
    +'</div>';
  }

  if(isMobile){
    var cardsHtml=pageRows.map(function(c){
      var cid=String(c.cart_id||"");
      var contacted=isContacted(cid);
      var time=relTime(c.updated_at)||"—";
      var badge=c._naopago
        ?'<span class="mc-ca-badge is-naopago">N\xe3o pago</span>'
        :safeRecorrente(c)
          ?'<span class="mc-ca-badge is-rec">'+safePedidosAnt(c)+' ped. anteriores</span>'
          :'<span class="mc-ca-badge is-new">Novo cliente</span>';
      var si=sourceInfo(c);
      var srcPill='<span class="mc-ca-badge mc-ca-src '+esc(si.cls||'')+'">'+esc(si.label)+'</span>';
      var wa='<a class="mcard-zap mc-ca-btn-wa" href="#" aria-label="WhatsApp" data-phone="'+esc(c.phone||'')+'" data-nome="'+esc(c.nome||'')+'" data-total="'+esc(String(c.total||0))+'" data-link="'+esc(c.purchase_url||'')+'" data-cid="'+esc(cid)+'"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.7 1-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.4.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1.1 2.8 1.2 3c.1.2 2.1 3.2 5 4.5.7.3 1.2.5 1.7.6.7.2 1.3.2 1.8.1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.1-.3-.2-.6-.3zM12 0C5.4 0 0 5.4 0 12c0 2.1.6 4.2 1.6 6L0 24l6.2-1.6C8 23.4 10 24 12 24c6.6 0 12-5.4 12-12S18.6 0 12 0zm0 22c-1.8 0-3.6-.5-5.2-1.4l-.4-.2-3.7 1 1-3.6-.2-.4C2.5 15.6 2 13.8 2 12 2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10z"/></svg></a>';
      return '<div class="mc-ca-row mc-ca-mcard'+(contacted&&_tab!=="contatados"?' is-contacted':'')+'" data-cid="'+esc(cid)+'">'
        +'<div class="mcard-top"><span class="mcard-price">'+BRL(c.total)+'</span><span class="mcard-time">'+esc(time)+'</span></div>'
        +'<div class="mcard-name">'+esc(c.nome||'—')+'</div>'
        +'<div class="mcard-badges"><div class="mcard-pills">'+badge+srcPill+'</div>'+wa+'</div>'
      +'</div>';
    }).join('');
    grid.innerHTML='<div class="mc-ca-mcards">'+cardsHtml+'</div>'+pager;
  } else {
    grid.innerHTML='<div class="mc-conv-table-wrap"><table class="mc-conv-table mc-conv-table-full mc-ca-table"><thead>'+thead+'</thead><tbody>'+tbody+'</tbody></table></div>'+pager;
  }

  var pg=grid.querySelector('.mc-ca-pager');
  if(pg){
    pg.addEventListener('click',function(ev){
      var b=ev.target.closest('.mc-ca-pg-btn'); if(!b||b.disabled) return;
      _listPage+=(b.dataset.pg==='next'?1:-1);
      renderCartList(list);
      var wrap=grid.querySelector('.mc-conv-table-wrap'); if(wrap) wrap.scrollIntoView({block:'nearest'});
    });
  }
}

/* ═══════════════════════════════════════
   CONVERSÕES VIEW
═══════════════════════════════════════ */
var _tab="abandonados", chartRange="max", showValLine=false;
var _convSort={k:"ultima_compra",dir:-1};
var METHODS=["WhatsApp","Email","SMS","Outro"], _methods={};
function getMethod(cid){ return _methods[String(cid)]||"—"; }
function setMethod(cid,m){ _methods[String(cid)]=m; }

function fmtDtS_(v){ var d=parseDate(v);if(!d)return "—"; return d.toLocaleDateString("pt-BR"); }
function convTempo_(c){
  var ud=parseDate(c.updated_at),lp=parseDate(c.ultima_compra);
  if(!ud||!lp) return{txt:"—",cls:""};
  var mins=(lp-ud)/60000; if(mins<0) return{txt:"—",cls:""};
  var txt,cls="";
  if(mins<60){txt=Math.round(mins)+"min";cls="fast";}
  else if(mins<1440){txt=(mins/60).toFixed(1).replace(".",",")+"h";}
  else{var dy=Math.round(mins/1440);txt=dy+"d";if(dy>3)cls="slow";}
  return{txt:txt,cls:cls};
}

function pad2_(n){ return n<10?"0"+n:String(n); }

function groupCartsByTime_(carts,cr){
  var isDaily=(cr==="7d"||cr==="hoje"), isWeekly=(cr==="30d"), isMonthly=(cr==="max");
  if(isMonthly&&carts.length){
    var dts=carts.map(function(c){return parseDate(c.updated_at);}).filter(Boolean);
    if(dts.length){
      var span=(Math.max.apply(null,dts.map(function(d){return d.getTime();}))-Math.min.apply(null,dts.map(function(d){return d.getTime();})))/864e5;
      if(span<=14){isMonthly=false;isDaily=true;}else if(span<=90){isMonthly=false;isWeekly=true;}
    }
  }
  function bk(d){
    if(isDaily) return d.getFullYear()+"-"+pad2_(d.getMonth()+1)+"-"+pad2_(d.getDate());
    if(isWeekly){var d2=new Date(d);d2.setDate(d2.getDate()-d2.getDay());return d2.getFullYear()+"-"+pad2_(d2.getMonth()+1)+"-"+pad2_(d2.getDate());}
    return d.getFullYear()+"-"+pad2_(d.getMonth()+1);
  }
  var cutoff=cr==="7d"?new Date(Date.now()-7*864e5):cr==="30d"?new Date(Date.now()-30*864e5):null;
  var map={};
  carts.forEach(function(c){
    var d=parseDate(c.updated_at);if(!d)return;if(cutoff&&d<cutoff)return;
    var k=bk(d);if(!map[k])map[k]={total:0,rec:0,val:0};
    map[k].total++;
    var lp=parseDate(c.ultima_compra);if(lp&&lp>d){map[k].rec++;map[k].val+=(c.total||0);}
  });
  var keys=Object.keys(map).sort();
  return{keys:keys,rates:keys.map(function(k){return map[k].total?map[k].rec/map[k].total*100:0;}),vals:keys.map(function(k){return map[k].rec?map[k].val/map[k].rec:0;})};
}

function buildChartSvg_(keys,rates,vals,showV){
  var W=700,H=160,pl=38,pr=16,pt=16,pb=32,iW=W-pl-pr,iH=H-pt-pb,n=keys.length;
  if(n<2)return'<p class="mc-empty" style="padding:32px 0;text-align:center;font-size:11px">Poucos dados para exibir o gráfico</p>';
  var maxR=Math.max.apply(null,rates.concat([1])),maxV=Math.max.apply(null,vals.concat([1]));
  function px(i){return pl+(n>1?i/(n-1)*iW:iW/2);}
  function pyR(v){return pt+iH-(v/maxR)*iH;}
  function pyV(v){return pt+iH-(v/maxV)*iH;}
  var g="";
  [0,.25,.5,.75,1].forEach(function(f){var pct=Math.round(maxR*f),y=pyR(maxR*f);g+='<line x1="'+pl+'" y1="'+y+'" x2="'+(W-pr)+'" y2="'+y+'" stroke="var(--line,#1e1e1e)" stroke-width="1"/><text x="'+(pl-4)+'" y="'+(y+3)+'" text-anchor="end" font-size="8" fill="var(--mut,#8a8a8a)">'+pct+'%</text>';});
  var step=Math.max(1,Math.floor(n/7)),xl="";
  keys.forEach(function(k,i){if(i%step!==0&&i!==n-1)return;var p=k.split("-");var lbl=p.length===3?p[2]+"/"+p[1]:p[1]+"/"+(p[0]||"").slice(2);xl+='<text x="'+px(i)+'" y="'+(H-6)+'" text-anchor="middle" font-size="8" fill="var(--mut,#8a8a8a)">'+lbl+'</text>';});
  var rpts=rates.map(function(v,i){return px(i)+","+pyR(v);}).join(" ");
  var vpts=vals.map(function(v,i){return px(i)+","+pyV(v);}).join(" ");
  var lastR=rates[n-1];
  return'<svg viewBox="0 0 '+W+' '+H+'" style="width:100%;display:block">'
    +g+'<polyline points="'+rpts+'" fill="none" stroke="var(--acc,#fff200)" stroke-width="2" stroke-linejoin="round"/>'
    +(showV?'<polyline points="'+vpts+'" fill="none" stroke="var(--good,#48f91e)" stroke-width="1.5" opacity=".85"/>':'')
    +'<circle cx="'+px(n-1)+'" cy="'+pyR(lastR)+'" r="3" fill="var(--acc,#fff200)"/>'
    +'<text x="'+(px(n-1)-5)+'" y="'+(pyR(lastR)-7)+'" text-anchor="end" font-size="9" fill="var(--acc,#fff200)">'+lastR.toFixed(1)+'%</text>'
    +xl+'</svg>';
}

function redrawChart_(){ var el=document.getElementById("mc-rec-chart");if(!el)return;var b=groupCartsByTime_(allCarts,chartRange);el.innerHTML=buildChartSvg_(b.keys,b.rates,b.vals,showValLine); }

var CONV_COLS=[
  {k:"order_id",        label:"Pedido",         t:"pedido"},
  {k:"ultima_compra",   label:"Data Pedido",     t:"dt"},
  {k:"updated_at",      label:"Data Carrinho",   t:"dt"},
  {k:"nome",            label:"Cliente",         t:"cliente"},
  {k:"tempo",           label:"Tempo",           t:"tempo"},
  {k:"canal",           label:"Canal",           t:"canal"},
  {k:"campanha",        label:"Modelo",          t:"text"},
  {k:"cupom",           label:"Cupom",           t:"cupom"},
  {k:"utm_source",      label:"1º Acesso",       t:"tag"},
  {k:"utm_source_sessao",label:"Sessão",         t:"tag"},
  {k:"categoria_vip",   label:"VIP",             t:"vip"},
  {k:"itens_qtd",       label:"Itens",           t:"itens"},
  {k:"total",           label:"Valor",           t:"brl"}
];

function renderConvLiquid(){
  var conv=convList();   // pedidos com cupom qualificador no período

  /* ── KPIs ── */
  var totalVal=conv.reduce(function(s,c){return s+(c.total||0);},0);
  var taxaRec=allCarts.length?Math.round(conv.length/allCarts.length*100):0;
  var ticket=conv.length?totalVal/conv.length:0;
  var mins=[]; conv.forEach(function(c){var ud=parseDate(c.updated_at),lp=parseDate(c.ultima_compra);if(ud&&lp&&lp>ud)mins.push((lp-ud)/60000);});
  var avgMins=mins.length?mins.reduce(function(s,t){return s+t;},0)/mins.length:0;
  function tempoTxt_(m){if(m<60)return Math.round(m)+"min";if(m<1440)return (m/60).toFixed(1).replace(".",",")+"h";return Math.round(m/1440)+"d";}
  var avgTempoTxt=mins.length?tempoTxt_(avgMins):"—";

  var kpisHtml='<div class="mc-conv-kpis">'
    +'<div class="mc-conv-kpi"><div class="mc-conv-kpi-lbl">Recuperados</div><div class="mc-conv-kpi-val" style="color:var(--good)">'+NUM(conv.length)+'</div></div>'
    +'<div class="mc-conv-kpi"><div class="mc-conv-kpi-lbl">Valor recuperado</div><div class="mc-conv-kpi-val" style="color:var(--acc)">'+BRL(totalVal)+'</div></div>'
    +'<div class="mc-conv-kpi"><div class="mc-conv-kpi-lbl">Taxa de recuperação</div><div class="mc-conv-kpi-val">'+taxaRec+'%</div></div>'
    +'<div class="mc-conv-kpi"><div class="mc-conv-kpi-lbl">Ticket médio</div><div class="mc-conv-kpi-val">'+BRL(ticket)+'</div></div>'
    +'<div class="mc-conv-kpi"><div class="mc-conv-kpi-lbl">Tempo médio</div><div class="mc-conv-kpi-val" style="font-size:16px">'+avgTempoTxt+'</div></div>'
    +'</div>';

  /* ── Chart (full width) ── */
  var b=groupCartsByTime_(allCarts,chartRange);
  var rngBtns=["7d","30d","max"].map(function(r){return'<button class="mc-chart-rng'+(chartRange===r?" is-active":"")+'" data-cr="'+r+'">'+(r==="max"?"Máximo":r)+'</button>';}).join("");
  var valBtn='<button id="mc-val-toggle" class="mc-chart-rng'+(showValLine?" is-active is-green":"")+'">'+(showValLine?"✕ Valor médio":"+ Valor médio")+'</button>';
  var chartHtml='<div class="mc-conv-chart-panel"><div class="mc-conv-chart-ctrl"><span class="mc-conv-chart-lbl">taxa de recuperação ao longo do tempo</span><div style="display:flex;gap:5px;flex-wrap:wrap">'+rngBtns+valBtn+'</div></div><div id="mc-rec-chart">'+buildChartSvg_(b.keys,b.rates,b.vals,showValLine)+'</div></div>';

  /* ── Sorted rows ── */
  var sorted=conv.slice().sort(function(a,b){
    var k=_convSort.k,dir=_convSort.dir;
    if(k==="ultima_compra"||k==="updated_at"){var da=parseDate(a[k])||new Date(0),db=parseDate(b[k])||new Date(0);return dir*(da-db);}
    if(k==="tempo"){var va=(parseDate(a.ultima_compra)||0)-(parseDate(a.updated_at)||0),vb=(parseDate(b.ultima_compra)||0)-(parseDate(b.updated_at)||0);return dir*(va-vb);}
    if(k==="total"){return dir*((Number(a.total)||0)-(Number(b.total)||0));}
    return dir*String(a[k]||"").localeCompare(String(b[k]||""));
  });

  function sortArrow(k){return _convSort.k===k?(_convSort.dir===1?" ↑":" ↓"):" ";}

  var thead='<tr>'+CONV_COLS.map(function(col){
    var r=col.t==="brl"?' class="r"':'';
    return'<th'+r+' data-cvk="'+esc(col.k)+'" style="cursor:pointer;user-select:none">'+esc(col.label)+'<span style="color:var(--acc);font-size:9px">'+sortArrow(col.k)+'</span></th>';
  }).join('')+'</tr>';

  function cellVal(col,c){
    var v=c[col.k];
    switch(col.t){
      case"pedido":
        var oid=c.order_id||c.order_number;
        if(!oid)return'<td style="color:var(--mut)">—</td>';
        return'<td><a href="'+esc(PAGE_PEDIDO+"?id="+encodeURIComponent(oid))+'" style="color:var(--acc);text-decoration:none;font-weight:700">#'+esc(String(oid))+'</a></td>';
      case"dt":
        return'<td style="color:var(--mut);font-size:11px">'+esc(fmtDtS_(v))+'</td>';
      case"cliente":
        var nm=esc(c.nome||"—");
        return c.customer_id
          ?'<td><a href="'+esc(PAGE_CLIENTE+"?id="+encodeURIComponent(c.customer_id))+'" style="color:var(--ink);text-decoration:none">'+nm+'</a></td>'
          :'<td>'+nm+'</td>';
      case"tempo":
        var t=convTempo_(c);
        return'<td><span class="mc-conv-tempo '+t.cls+'">'+esc(t.txt)+'</span></td>';
      case"canal":
        var src=sourceInfo(c);
        return'<td><span class="mc-ca-origem '+src.cls+'">'+esc(src.label)+'</span></td>';
      case"text":
        var tv=(v==null||v==="")?"—":String(v);
        return'<td style="color:var(--mut);font-size:11px;max-width:160px;overflow:hidden;text-overflow:ellipsis">'+esc(tv)+'</td>';
      case"cupom":
        if(!v||v==="")return'<td style="color:var(--mut)">—</td>';
        return'<td><span style="font-size:10px;letter-spacing:.06em;color:var(--acc);background:rgba(255,242,0,.07);padding:2px 7px;border:1px solid rgba(255,242,0,.2)">'+esc(v)+'</span></td>';
      case"tag":
        return'<td style="font-size:11px;color:var(--mut)">'+esc(v||"—")+'</td>';
      case"vip":
        if(!v||v==="")return'<td style="color:var(--mut)">—</td>';
        return'<td><span style="font-size:10px;padding:2px 7px;background:rgba(255,242,0,.1);border:1px solid rgba(255,242,0,.3);color:var(--acc)">'+esc(v)+'</span></td>';
      case"itens":
        var n=Number(v)||0;
        var itms=c.items||c.lineitems||c.line_items||[];
        var itipArr=Array.isArray(itms)?itms.map(function(i){return(i.title||i.name||"Item")+" x"+(i.quantity||1);}):[];
        return'<td><span class="mc-conv-items" data-items="'+esc(itipArr.join("||"))+'">'+(n?n+" item"+(n!==1?"s":""):"—")+'</span></td>';
      case"brl":
        return'<td class="r" style="font-weight:700;color:var(--acc)">'+BRL(Number(v)||0)+'</td>';
      default:
        return'<td>'+esc(v==null?"—":v)+'</td>';
    }
  }

  var tbody=sorted.length
    ?sorted.map(function(c){return'<tr class="mc-conv-row" data-cid="'+esc(String(c.cart_id||""))+'" style="cursor:pointer">'+CONV_COLS.map(function(col){return cellVal(col,c);}).join('')+'</tr>';}).join('')
    :'<tr><td class="mc-empty" colspan="'+CONV_COLS.length+'">Nenhuma conversão no período</td></tr>';

  var isMobileC=(window.matchMedia&&window.matchMedia('(max-width:600px)').matches)||window.innerWidth<=600;
  var tableHtml;
  if(isMobileC){
    var chkS='<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
    var chkB='<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
    var cardsC=sorted.length?sorted.map(function(c){
      var si=sourceInfo(c);
      var srcPill='<span class="mc-ca-badge mc-ca-src '+esc(si.cls||'')+'">'+esc(si.label)+'</span>';
      var recPill='<span class="mc-ca-badge is-new">'+chkS+'Recuperado</span>';
      var dt=fmtDtS_(c.ultima_compra||c.updated_at);
      return '<div class="mc-conv-row mc-ca-mcard" data-cid="'+esc(String(c.cart_id||''))+'">'
        +'<div class="mcard-top"><span class="mcard-price" style="color:#3ddc84">'+BRL(c.total)+'</span><span class="mcard-time">'+esc(dt)+'</span></div>'
        +'<div class="mcard-name">'+esc(c.nome||'—')+'</div>'
        +'<div class="mcard-badges"><div class="mcard-pills">'+recPill+srcPill+'</div></div>'
      +'</div>';
    }).join(''):'<p class="mc-empty">Nenhuma conversão no período</p>';
    tableHtml='<div class="mc-ca-mcards">'+cardsC+'</div>';
  } else {
    tableHtml='<div class="mc-conv-table-wrap"><table class="mc-conv-table mc-conv-table-full"><thead>'+thead+'</thead><tbody>'+tbody+'</tbody></table></div>';
  }

  var liq=document.getElementById("ca-conv-liquid");
  if(liq) liq.innerHTML=tableHtml+chartHtml;
}

root.addEventListener("click",function(ev){
  /* tabs: carrinhos / conversões */
  var tb=ev.target.closest("[data-tab]");
  if(tb){
    _tab=tb.dataset.tab;
    document.querySelectorAll("[data-tab]").forEach(function(b){b.classList.toggle("is-active",b.dataset.tab===_tab);});
    currentPage=1; _carIdx=0;
    render();
    return;
  }
  var mb=ev.target.closest(".mc-conv-method");
  if(mb){var cid=mb.dataset.cid,cur=mb.dataset.m,idx=METHODS.indexOf(cur),next=METHODS[(idx+1)%METHODS.length];setMethod(cid,next);mb.dataset.m=next;mb.textContent=next;return;}
  /* clique numa linha de conversão abre o detalhe do carrinho
     (links de pedido/cliente e o tooltip de itens continuam funcionando) */
  var convRow=ev.target.closest(".mc-conv-row");
  if(convRow && !ev.target.closest("a") && !ev.target.closest(".mc-conv-items")){
    openDetailModal(convRow.dataset.cid); return;
  }
  var rb=ev.target.closest("[data-cr]");
  if(rb){chartRange=rb.getAttribute("data-cr");root.querySelectorAll(".mc-chart-rng[data-cr]").forEach(function(b){b.classList.toggle("is-active",b.getAttribute("data-cr")===chartRange);});redrawChart_();return;}
  if(ev.target.closest("#mc-val-toggle")){showValLine=!showValLine;var vb=ev.target.closest("#mc-val-toggle");vb.classList.toggle("is-active",showValLine);vb.classList.toggle("is-green",showValLine);vb.textContent=showValLine?"✕ Valor médio":"+ Valor médio";redrawChart_();return;}
  /* sort conversões table */
  var th=ev.target.closest("th[data-cvk]");
  if(th){var k=th.dataset.cvk;if(_convSort.k===k)_convSort.dir=-_convSort.dir;else{_convSort.k=k;_convSort.dir=-1;}renderConvLiquid();return;}
  /* sort lista de carrinhos */
  var thc=ev.target.closest("th[data-ctk]");
  if(thc){var kc=thc.dataset.ctk;if(_cartSort.k===kc)_cartSort.dir=-_cartSort.dir;else{_cartSort.k=kc;_cartSort.dir=-1;}_listPage=1;renderCards(filtered());return;}
});

/* items tooltip for conv table */
var _convTip=null;
root.addEventListener("mouseover",function(ev){
  var el=ev.target.closest(".mc-conv-items");
  if(!el)return;
  if(!_convTip){_convTip=document.createElement("div");_convTip.className="mc-ptip";_convTip.style.cssText="position:fixed;z-index:9999;pointer-events:none;background:#0d0d0d;border:1px solid #2a2a2a;padding:9px 12px;font-size:11px;line-height:1.7;display:none;min-width:160px";root.appendChild(_convTip);}
  var items=(el.dataset.items||"").split("||").filter(Boolean);
  _convTip.innerHTML=items.length?items.map(function(i){return'<div style="color:var(--ink)">'+esc(i)+'</div>';}).join(''):'<div style="color:var(--mut)">Sem detalhes</div>';
  var rect=el.getBoundingClientRect();
  var x=rect.left,y=rect.bottom+4;
  if(x+180>window.innerWidth)x=window.innerWidth-184;
  if(y+120>window.innerHeight)y=rect.top-4-_convTip.offsetHeight;
  _convTip.style.left=x+"px";_convTip.style.top=y+"px";_convTip.style.display="block";
});
root.addEventListener("mouseout",function(ev){
  if(ev.target.closest(".mc-conv-items")&&!ev.relatedTarget?.closest(".mc-conv-items"))
    {if(_convTip)_convTip.style.display="none";}
});

/* ═══════════════════════════════════════
   INSIGHTS — CHART HELPERS
═══════════════════════════════════════ */
function buildVertBarSvg(labels, values, color){
  var n=labels.length; if(!n) return '<p class="mc-empty">Sem dados</p>';
  var W=260,H=110,padT=18,padB=20,padLR=4;
  var barArea=H-padT-padB;
  var max=Math.max.apply(null,values.concat([1]));
  var slot=(W-padLR*2)/n;
  var barW=Math.max(6,Math.floor(slot*0.55));
  var svg='<svg viewBox="0 0 '+W+' '+H+'" style="width:100%;display:block;overflow:visible">';
  labels.forEach(function(lbl,i){
    var x=padLR+i*slot+(slot-barW)/2;
    var bh=Math.max(2,Math.round(values[i]/max*barArea));
    var y=padT+barArea-bh;
    svg+='<rect x="'+x.toFixed(1)+'" y="'+y.toFixed(1)+'" width="'+barW+'" height="'+bh+'" fill="'+(color||'var(--acc)')+'"/>';
    var tv=values[i]>9999?(values[i]/1000).toFixed(1)+'k':String(values[i]);
    svg+='<text x="'+(x+barW/2).toFixed(1)+'" y="'+(y-3).toFixed(1)+'" text-anchor="middle" font-size="7" fill="'+(color||'var(--acc)')+'">'+esc(tv)+'</text>';
    var ls=String(lbl); if(ls.length>7) ls=ls.slice(0,6)+'…';
    svg+='<text x="'+(x+barW/2).toFixed(1)+'" y="'+(H-3).toFixed(1)+'" text-anchor="middle" font-size="7" fill="var(--mut)">'+esc(ls)+'</text>';
  });
  svg+='</svg>';
  return svg;
}

function buildPieSvg(labels, values){
  var total=values.reduce(function(s,v){return s+v;},0);
  if(!total) return '<p class="mc-empty">Sem dados</p>';
  var COLORS=['#fff200','#48f91e','#4da6ff','#f5a623','#ff4d4d','#c084fc','#fb923c'];
  var cx=58,cy=55,r=46,W=220,H=110;
  var svg='<svg viewBox="0 0 '+W+' '+H+'" style="width:100%;display:block">';
  var angle=-Math.PI/2;
  values.forEach(function(v,i){
    var slice=(v/total)*Math.PI*2; if(slice<0.02){angle+=slice;return;}
    var x1=cx+r*Math.cos(angle), y1=cy+r*Math.sin(angle);
    angle+=slice;
    var x2=cx+r*Math.cos(angle), y2=cy+r*Math.sin(angle);
    var large=slice>Math.PI?1:0;
    svg+='<path d="M'+cx+' '+cy+' L'+x1.toFixed(1)+' '+y1.toFixed(1)+' A'+r+' '+r+' 0 '+large+' 1 '+x2.toFixed(1)+' '+y2.toFixed(1)+' Z" fill="'+COLORS[i%COLORS.length]+'" opacity="0.85"/>';
  });
  var legX=118,legY=12,maxLeg=Math.min(labels.length,6);
  for(var li=0;li<maxLeg;li++){
    var pct=Math.round(values[li]/total*100);
    var ll=String(labels[li]); if(ll.length>11) ll=ll.slice(0,10)+'…';
    svg+='<rect x="'+legX+'" y="'+(legY-7)+'" width="7" height="7" fill="'+COLORS[li%COLORS.length]+'"/>';
    svg+='<text x="'+(legX+10)+'" y="'+legY+'" font-size="7.5" fill="var(--ink)">'+esc(ll)+' <tspan fill="var(--mut)">'+pct+'%</tspan></text>';
    legY+=14;
  }
  svg+='</svg>';
  return svg;
}

/* ═══════════════════════════════════════
   INSIGHTS — CARROSSEL
═══════════════════════════════════════ */
var _insOffset=0;

function renderInsights(carts){
  var el=document.getElementById("ca-insights");
  if(!carts.length){el.style.display="none";return;}
  el.style.display="";

  var panels=[];

  /* Etapa de abandono — barras verticais */
  var etapaCount={};
  carts.forEach(function(c){var e=c.etapa||"Desconhecida";etapaCount[e]=(etapaCount[e]||0)+1;});
  var etKeys=Object.keys(etapaCount).sort(function(a,b){return etapaCount[b]-etapaCount[a];}).slice(0,8);
  panels.push({title:"Etapa de abandono", chart:buildVertBarSvg(etKeys,etKeys.map(function(k){return etapaCount[k];}), "var(--acc)")});

  /* Origem — pizza */
  var srcCount={};
  carts.forEach(function(c){var s=sourceInfo(c).label;srcCount[s]=(srcCount[s]||0)+1;});
  var srKeys=Object.keys(srcCount).sort(function(a,b){return srcCount[b]-srcCount[a];});
  panels.push({title:"Origem", chart:buildPieSvg(srKeys,srKeys.map(function(k){return srcCount[k];}))});

  /* Ticket médio por etapa — barras verticais */
  var etVal={};
  carts.forEach(function(c){var e=c.etapa||"Desconhecida";if(!etVal[e])etVal[e]={s:0,n:0};etVal[e].s+=c.total||0;etVal[e].n++;});
  var tkKeys=Object.keys(etVal).sort(function(a,b){return(etVal[b].s/etVal[b].n)-(etVal[a].s/etVal[a].n);}).slice(0,8);
  panels.push({title:"Ticket médio / etapa", chart:buildVertBarSvg(tkKeys,tkKeys.map(function(k){return Math.round(etVal[k].s/etVal[k].n);}), "var(--good)")});

  /* Horário de abandono — barras verticais */
  var hourCount=Array(24).fill(0);
  carts.forEach(function(c){var d=parseDate(c.updated_at);if(d)hourCount[d.getHours()]++;});
  var hLabels=[],hVals=[];
  hourCount.forEach(function(v,h){if(v>0){hLabels.push(String(h).padStart(2,"0")+"h");hVals.push(v);}});
  if(hLabels.length) panels.push({title:"Horário de abandono", chart:buildVertBarSvg(hLabels,hVals,"var(--warn)")});

  var N=panels.length, MAX_VIS=3;
  if(_insOffset>Math.max(0,N-MAX_VIS)) _insOffset=Math.max(0,N-MAX_VIS);

  function drawCarousel(){
    var vis=panels.slice(_insOffset,_insOffset+MAX_VIS);
    var hasPrev=_insOffset>0, hasNext=_insOffset+MAX_VIS<N;
    var html='<div class="mc-ins-carousel">';
    html+='<button class="mc-ins-nav mc-ins-prev"'+(hasPrev?'':' disabled')+'>&#8249;</button>';
    html+='<div class="mc-ins-panels">';
    vis.forEach(function(p){
      html+='<div class="mc-ins-panel"><div class="mc-ins-panel-title">'+esc(p.title)+'</div><div class="mc-ins-chart">'+p.chart+'</div></div>';
    });
    html+='</div>';
    html+='<button class="mc-ins-nav mc-ins-next"'+(hasNext?'':' disabled')+'>&#8250;</button>';
    html+='</div>';
    el.innerHTML=html;
    el.querySelector('.mc-ins-prev').onclick=function(){if(_insOffset>0){_insOffset--;drawCarousel();}};
    el.querySelector('.mc-ins-next').onclick=function(){if(_insOffset+MAX_VIS<N){_insOffset++;drawCarousel();}};
  }
  drawCarousel();
}

/* ═══════════════════════════════════════
   PAGINATION & RENDER
═══════════════════════════════════════ */
var allCarts=[], range="7d", currentPage=1;
/* ── Estado do carrossel ── */
var _carIdx=0, _carList=[], _carSlots=[], _carAnimating=false;
var CAR_STEP=278, CAR_VISIBLE=4;

/* convertido = comprou depois de abandonar (última compra > abandono) */
function isConverted(c){ var ud=parseDate(c.updated_at)||new Date(0); var lp=parseDate(c.ultima_compra); return !!(lp&&lp>ud); }
function filtered(){
  if(_tab==="convertidos") return convList();
  var list=allCarts.filter(function(c){
    if(isConvertedFinal(c)) return false;      // cliente já comprou → sai de abandonados/contatados
    var cont=isContacted(String(c.cart_id));
    if(_tab==="contatados") return cont;       // contatados (ainda não convertidos)
    return !cont;                              // abandonados (não contatados)
  });
  list.sort(function(a,b){var da=parseDate(a.updated_at)||new Date(0),db=parseDate(b.updated_at)||new Date(0);return db-da;});
  return list;
}

function render(){
  var list=filtered();
  var mcRoot=document.getElementById("mc-root");
  if(mcRoot) mcRoot.classList.toggle("ca-conv-tab", _tab==="convertidos");
  var wrap=document.querySelector(".mc-ca-carousel-wrap");
  var ins=document.getElementById("ca-insights");
  var liq=document.getElementById("ca-conv-liquid");
  if(_tab==="convertidos"){
    if(wrap) wrap.style.display="none";
    if(ins) ins.style.display="none";
    if(liq){ liq.style.display=""; renderConvLiquid(); }
    updateKPIs(list);
  } else {
    if(wrap) wrap.style.display="";
    if(liq) liq.style.display="none";
    renderCards(list); /* tabela + insights + KPIs */
  }
}

/* ── Grade flat paginada (4 por linha, paginação em cima) ── */
var CARDS_PER_PAGE=3;

/* navegação de página (usada por teclado / scroll / botões) */
function carouselStep(dir){
  var pages=Math.ceil(_carList.length/CARDS_PER_PAGE);
  if(pages<=1) return;
  var np=currentPage+dir;
  if(np<1) np=pages; if(np>pages) np=1;
  currentPage=np;
  renderCards(_carList);
}

function renderCards(list){
  _carList=list;
  renderCartList(list);
  var cnt=document.getElementById("ca-count");
  if(cnt) cnt.textContent=NUM(list.length);
  renderInsights(list);
  updateKPIs(list);
}

/* partições por aba (para agregação nos KPIs) */
function partContatados(){ return allCarts.filter(function(c){ return !isConvertedFinal(c) && isContacted(String(c.cart_id)); }); }
function partConvertidos(){ return convList(); }
function updateKPIs(list){
  // "Carrinhos" e "Valor total" agregam outras abas conforme a aba atual:
  //  - abandonados: abandonados + contatados + convertidos
  //  - contatados : contatados + convertidos
  // "Ticket médio" (e recorrentes/taxa) refletem SÓ a aba atual.
  var countList=list;
  if(_tab==="abandonados")      countList=list.concat(partContatados(), partConvertidos());
  else if(_tab==="contatados")  countList=list.concat(partConvertidos());
  var total=countList.length;
  var val=countList.reduce(function(s,c){return s+(c.total||0);},0);
  var tabTotal=list.length;
  var tabVal=list.reduce(function(s,c){return s+(c.total||0);},0);
  var tk=tabTotal?tabVal/tabTotal:0;
  var rec=list.filter(function(c){return c.recorrente;}).length;
  var conv=list.filter(function(c){ return isConvertedFinal(c); });
  var taxaRec=tabTotal?Math.round(conv.length/tabTotal*100):0;
  var setK=function(id,v){var el=document.getElementById(id);if(el)el.textContent=v;};
  setK("cs-n",NUM(total)); setK("cs-val",BRL(val)); setK("cs-tk",BRL(tk));
  setK("cs-rec",NUM(rec)); setK("cs-rec-rate",taxaRec+"%");
}

function renderPages(){ /* substituído pelo carrossel */ }

/* ═══════════════════════════════════════
   LOAD
═══════════════════════════════════════ */
/* re-render ao cruzar o breakpoint mobile/desktop (tabela ↔ cards) */
var _wasMobileCa=null, _resizeCaT=null;
window.addEventListener('resize',function(){
  clearTimeout(_resizeCaT);
  _resizeCaT=setTimeout(function(){
    var m=(window.matchMedia&&window.matchMedia('(max-width:600px)').matches)||window.innerWidth<=600;
    if(m!==_wasMobileCa){ _wasMobileCa=m;
      try{ if(_tab!=="convertidos") renderCartList(filtered()); else if(typeof renderConvLiquid==="function") renderConvLiquid(); }catch(e){}
    }
  },160);
});
function cartMs(s){ if(!s) return 0; return Date.parse(String(s).replace(' ','T'))||0; }
/* janela [from,to] em ms de um range, espelhando periodWindow_ do backend */
function rangeWindow(r){
  r=String(r||'').toLowerCase();
  var n=new Date();
  var tod=new Date(n.getFullYear(),n.getMonth(),n.getDate());
  var todEnd=new Date(n.getFullYear(),n.getMonth(),n.getDate(),23,59,59);
  if(r.indexOf('~')>0){ var p=r.split('~'); return {from:new Date(p[0]+'T00:00:00').getTime(), to:new Date(p[1]+'T23:59:59').getTime()}; }
  if(r==='hoje') return {from:tod.getTime(), to:todEnd.getTime()};
  if(r==='hoje_ontem') return {from:new Date(n.getFullYear(),n.getMonth(),n.getDate()-1).getTime(), to:todEnd.getTime()};
  if(r==='mes') return {from:new Date(n.getFullYear(),n.getMonth(),1).getTime(), to:todEnd.getTime()};
  if(r==='ano') return {from:new Date(n.getFullYear(),0,1).getTime(), to:todEnd.getTime()};
  if(r==='max') return {from:new Date(n.getFullYear(),n.getMonth()-24,n.getDate()).getTime(), to:null};
  if(r==='3d') return {from:n.getTime()-3*864e5, to:null};
  if(r==='7d') return {from:n.getTime()-7*864e5, to:null};
  if(r==='14d') return {from:n.getTime()-14*864e5, to:null};
  if(r==='30d') return {from:n.getTime()-30*864e5, to:null};
  if(r==='90d') return {from:n.getTime()-90*864e5, to:null};
  return {from:null, to:null};
}
/* base cobre completamente a janela pedida? */
function baseCovers(bw,rw){
  var fromOK = (bw.from==null) || (rw.from!=null && bw.from<=rw.from);
  var toOK   = (bw.to==null)   || (rw.to!=null   && bw.to>=rw.to);
  return fromOK && toOK;
}
function cartWinMs(c){ return cartMs(c.updated_at)||cartMs(c.created_at)||0; }
function filterCartsWindow(carts,w){
  return (carts||[]).filter(function(c){
    var m=cartWinMs(c);
    if(w.from!=null && m<w.from) return false;
    if(w.to!=null && m>w.to) return false;
    return true;
  });
}
/* pinta a lista a partir de um payload {carts:[...]} (sem esperar telefones) */
function caApply(d,extra){
  allCarts=(d&&d.carts)||[];
  function paint(){
    var f=filtered(), np=allCarts.filter(function(c){return c._naopago;}).length;
    $("#mc-sub").textContent="Yampi+Shopify \xB7 "+f.length+" carrinho"+(f.length!==1?"s":"")+(np?" ("+np+" n\xE3o pago)":"")+" \xB7 "+(extra||"atualizado agora");
    render();
  }
  paint();
  fetchMissingPhones(allCarts,function(){ paint(); });
}
function caSaveCache(key,d){ try{ localStorage.setItem('mc_carts_'+key,JSON.stringify({ts:Date.now(),d:d})); }catch(e){} }
function caHasAnyCache(){ try{ for(var i=0;i<localStorage.length;i++){ if(String(localStorage.key(i)).indexOf('mc_carts_')===0) return true; } }catch(e){} return false; }
function caIsoAgo(n){ var d=new Date(Date.now()-n*864e5); return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
function caIsoNow(){ var d=new Date(); return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
/* primeira abertura sem cache: mostra 3 dias rápido, depois baixa 90 dias em 2º plano */
function bootstrapCarts(){
  call({resource:"abandoned_carts", range:caIsoAgo(3)+'~'+caIsoNow()}).then(function(d){
    if(d&&!d.error){ caSaveCache('3d',d); caApply(d,"últimos 3 dias"); }
  }).catch(function(){}).then(function(){
    call({resource:"abandoned_carts", range:caIsoAgo(90)+'~'+caIsoNow()}).then(function(d90){
      if(d90&&!d90.error){ caSaveCache('90d',d90); load(); }  // vira base p/ derivação de qualquer período
    }).catch(function(){});
  });
}
function load(force){
  _listPage=1;
  var lsKey='mc_carts_'+range;
  var FRESH=3*60*1000, FULL=2*60*60*1000;
  var cached=null, cacheTs=0;
  try{ var s=localStorage.getItem(lsKey); if(s){ var j=JSON.parse(s); cached=j.d; cacheTs=j.ts||0; } }catch(e){}
  var applyData=caApply;
  function save(d){ caSaveCache(range,d); }
  if(cached){ applyData(cached); }
  // sem cache exato: deriva de um cache mais amplo que cubra o período (ex.: 90/30 dias)
  var derivedFresh=false;
  if(!cached){
    var rw=rangeWindow(range), best=null;
    // varre TODOS os caches de carrinhos (presets, custom '~' e '3d' do bootstrap)
    // e escolhe o mais recente que cubra a janela pedida
    try{
      for(var _i=0;_i<localStorage.length;_i++){
        var _k=localStorage.key(_i);
        if(String(_k).indexOf('mc_carts_')!==0) continue;
        var bk=_k.slice('mc_carts_'.length);
        if(bk===range) continue;
        try{ var bs=localStorage.getItem(_k); if(!bs) continue; var bj=JSON.parse(bs);
          if(baseCovers(rangeWindow(bk),rw)){ if(!best||bj.ts>best.ts) best={ts:bj.ts,d:bj.d}; }
        }catch(e){}
      }
    }catch(e){}
    if(best){ applyData({carts:filterCartsWindow((best.d&&best.d.carts)||[],rw)},"do cache");
      if(!force && Date.now()-best.ts<FRESH) derivedFresh=true; }
  }
  if(derivedFresh) return;
  var age=Date.now()-cacheTs;
  // cache fresco: mostra na hora e NÃO vai à rede (instantâneo) — a menos que force (botão reload)
  if(!force && cached && age<FRESH) return;
  // incremental (só os novos) se o cache não está muito velho; senão, recarrega tudo
  var incremental = !!(cached && age<FULL);
  var mergeBase = cached || (allCarts.length ? {carts:allCarts.slice()} : null);
  if(force && !incremental && mergeBase){ incremental=true; }   // reload otimizado a partir do que já está em tela
  var q={resource:"abandoned_carts",range:range};
  if(incremental && mergeBase){
    var newest=0; (mergeBase.carts||[]).forEach(function(c){ if(c._naopago) return; var m=cartMs(c.updated_at); if(m>newest) newest=m; });
    if(newest>0) q.since=newest; else incremental=false;
  } else incremental=false;
  if(cached||force) $("#mc-sub").textContent+=" \xB7 atualizando…";
  call(q).then(function(d){
    if(d&&d.error){ if(!allCarts.length) $("#ca-grid").innerHTML='<p class="mc-empty" style="color:var(--bad)">Erro: '+esc(d.error)+'</p>'; return; }
    var out=d;
    if(incremental && d.incremental && mergeBase){
      // mescla os novos com a base (mantém os "não pago" e os antigos)
      var map={}; (mergeBase.carts||[]).forEach(function(c){ map[String(c.cart_id)]=c; });
      (d.carts||[]).forEach(function(c){ map[String(c.cart_id)]=c; });
      out={carts:Object.keys(map).map(function(k){ return map[k]; })};
    }
    save(out); applyData(out);
  }).catch(function(e){
    if(!allCarts.length) $("#ca-grid").innerHTML='<p class="mc-empty" style="color:var(--bad)">Erro de rede</p>';
  });
}

/* ── Rangepicker (calendário estilo Aquisição) ── */
var CA_MONTHS=["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
var CA_PRESET_LABEL={hoje:'Hoje',hoje_ontem:'Hoje+Ontem','7d':'7 dias','30d':'30 dias',ano:'Ano',max:'Máximo'};
function caPresetKey(a,b){
  var t=new Date(); t.setHours(0,0,0,0);
  function iso(d){ return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
  var ea=iso(a), eb=iso(b), et=iso(t);
  if(ea===et&&eb===et) return 'hoje';
  if(ea===iso(new Date(t.getTime()-864e5))&&eb===et) return 'hoje_ontem';
  if(ea===iso(new Date(t.getTime()-6*864e5))&&eb===et) return '7d';
  if(ea===iso(new Date(t.getTime()-29*864e5))&&eb===et) return '30d';
  if(ea===iso(new Date(t.getFullYear(),0,1))&&eb===et) return 'ano';
  return null;
}
function caIso(d){ return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
function caBR(d){ return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2); }
function caSame(a,b){ return a&&b&&a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate(); }
function caSetRange(r, label){
  range=r; currentPage=1;
  var lbl=document.getElementById("ca-range-label"); if(lbl) lbl.textContent=label;
  try{ localStorage.setItem('mc_cart_range', JSON.stringify({r:r,label:label||''})); }catch(e){}
  load();
}
function caCal(container, toggle){
  if(!container||!toggle) return;
  var st={view:null,start:null,end:null,open:false,grid:null,title:null,rng:null};
  var today=new Date(); today.setHours(0,0,0,0);
  st.end=today; st.start=new Date(today.getTime()-29*864e5); st.view=new Date(today.getFullYear(),today.getMonth(),1);
  container.style.cssText="position:absolute;top:calc(100% + 6px);right:0;z-index:9000;display:none;background:#0f0f0f;border:1px solid #2a2a2a;box-shadow:0 18px 44px rgba(0,0,0,.6);flex-direction:row";
  var presets=[['hoje','Hoje'],['hoje_ontem','Hoje+Ontem'],['7d','7 dias'],['30d','30 dias'],['ano','Ano'],['max','Máximo']];
  var pBtn="text-align:left;padding:7px 10px;font-size:11px;text-transform:uppercase;letter-spacing:.04em;color:#8a8a8a;background:none;border:none;cursor:pointer;border-radius:6px;font-family:inherit;white-space:nowrap";
  container.innerHTML=
    '<div style="display:flex;flex-direction:column;padding:8px;gap:2px;border-right:1px solid #1e1e1e;min-width:112px">'
      +presets.map(function(o){ return '<button type="button" data-range="'+o[0]+'" style="'+pBtn+'">'+o[1]+'</button>'; }).join('')
    +'</div>'
    +'<div style="padding:12px 14px 10px;width:262px">'
      +'<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px">'
        +'<button type="button" class="ca-prev" style="width:28px;height:28px;background:none;border:none;color:#8a8a8a;cursor:pointer;font-size:20px;line-height:1">‹</button>'
        +'<span class="ca-title" style="font-size:13px;font-weight:600;color:#f5f5f5"></span>'
        +'<button type="button" class="ca-next" style="width:28px;height:28px;background:none;border:none;color:#8a8a8a;cursor:pointer;font-size:20px;line-height:1">›</button>'
      +'</div>'
      +'<div style="display:grid;grid-template-columns:repeat(7,1fr);text-align:center;font-size:10px;text-transform:uppercase;color:#8a8a8a;opacity:.7;margin-bottom:4px"><span>D</span><span>S</span><span>T</span><span>Q</span><span>Q</span><span>S</span><span>S</span></div>'
      +'<div class="ca-cal-grid" style="display:grid;grid-template-columns:repeat(7,1fr);gap:3px"></div>'
      +'<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;padding-top:9px;border-top:1px solid #1e1e1e">'
        +'<span class="ca-cal-rng" style="font-size:10.5px;color:#8a8a8a"></span>'
        +'<button type="button" class="ca-apply" style="padding:6px 14px;background:#fff200;color:#0a0a0a;border:none;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;cursor:pointer;font-family:inherit">Aplicar</button>'
      +'</div>'
    +'</div>';
  st.grid=container.querySelector('.ca-cal-grid'); st.title=container.querySelector('.ca-title'); st.rng=container.querySelector('.ca-cal-rng');
  function render(){
    var v=st.view; st.title.textContent=CA_MONTHS[v.getMonth()]+" "+v.getFullYear();
    var first=new Date(v.getFullYear(),v.getMonth(),1), gs=new Date(first.getTime()-first.getDay()*864e5), h="";
    var base="width:100%;height:32px;display:flex;align-items:center;justify-content:center;font-size:12px;background:none;border:none;cursor:pointer;font-family:inherit;border-radius:0;color:#f5f5f5";
    for(var i=0;i<42;i++){ var d=new Date(gs.getFullYear(),gs.getMonth(),gs.getDate()+i); var s=base;
      var outM=d.getMonth()!==v.getMonth();
      if(outM) s+=";color:#4a4a4a";
      var isS=caSame(d,st.start), isE=caSame(d,st.end);
      if(st.start&&st.end&&d>=st.start&&d<=st.end&&!isS&&!isE) s+=";background:rgba(255,242,0,.16);color:"+(outM?"#a5852a":"#f5f5f5");
      if((isS||isE)&&st.end) s+=";background:#fff200;color:#0a0a0a;font-weight:700;border-radius:0";
      if(isS&&!st.end) s+=";background:#fff200;color:#0a0a0a;font-weight:700;border-radius:0";
      if(caSame(d,today)&&!isS&&!isE) s+=";box-shadow:inset 0 0 0 1px #2a2a2a";
      h+='<button type="button" data-date="'+caIso(d)+'" style="'+s+'">'+d.getDate()+'</button>';
    }
    st.grid.innerHTML=h;
    if(st.start){ var e=st.end||st.start; st.rng.textContent=caBR(st.start)+((st.end&&!caSame(st.start,st.end))?(' – '+caBR(e)):''); } else st.rng.textContent="Selecione um período";
    Array.prototype.forEach.call(container.querySelectorAll('button[data-range]'),function(x){ x.style.color=(x.getAttribute('data-range')===range)?'#fff200':'#8a8a8a'; });
  }
  function syncFromRange(){
    var t=new Date(); t.setHours(0,0,0,0); var r=range;
    function set(a,b){ st.start=a; st.end=b; st.view=new Date((b||a||t).getFullYear(),(b||a||t).getMonth(),1); }
    if(r==='hoje') set(t,t);
    else if(r==='hoje_ontem') set(new Date(t.getTime()-864e5),t);
    else if(r==='7d') set(new Date(t.getTime()-6*864e5),t);
    else if(r==='30d') set(new Date(t.getTime()-29*864e5),t);
    else if(r==='ano') set(new Date(t.getFullYear(),0,1),t);
    else if(r==='max'){ st.start=null; st.end=null; st.view=new Date(t.getFullYear(),t.getMonth(),1); }
    else if(r&&r.indexOf('~')>0){ var p=r.split('~'); set(new Date(p[0]+'T00:00:00'), new Date(p[1]+'T00:00:00')); }
    else set(new Date(t.getTime()-6*864e5),t);
  }
  function caBackdrop(show){
    var bd=document.getElementById("ca-cal-backdrop");
    var mobile=(window.matchMedia&&window.matchMedia('(max-width:600px)').matches)||window.innerWidth<=600;
    if(show&&mobile){
      if(!bd){ bd=document.createElement("div"); bd.id="ca-cal-backdrop";
        bd.style.cssText="position:fixed;inset:0;z-index:8999;background:rgba(0,0,0,.55);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px)";
        bd.addEventListener("click",function(){ open(false); });
        document.body.appendChild(bd); }
      bd.style.display="block";
    } else if(bd){ bd.style.display="none"; }
  }
  function open(o){ st.open=o; container.style.display=o?'flex':'none'; caBackdrop(o); if(o){ syncFromRange(); render(); } }
  st._open=open;
  toggle.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); open(!st.open); });
  container.addEventListener('click',function(e){
    e.stopPropagation();
    var pre=e.target.closest('button[data-range]');
    if(pre){ open(false); caSetRange(pre.getAttribute('data-range'), pre.textContent.trim()); return; }
    if(e.target.closest('.ca-prev')){ st.view=new Date(st.view.getFullYear(),st.view.getMonth()-1,1); render(); return; }
    if(e.target.closest('.ca-next')){ st.view=new Date(st.view.getFullYear(),st.view.getMonth()+1,1); render(); return; }
    if(e.target.closest('.ca-apply')){ if(!st.start) return; var en=st.end||st.start; open(false);
      var pk=caPresetKey(st.start,en);
      if(pk){ caSetRange(pk, CA_PRESET_LABEL[pk]); } else { caSetRange(caIso(st.start)+'~'+caIso(en), caBR(st.start)+' - '+caBR(en)); }
      return; }
    var day=e.target.closest('button[data-date]');
    if(day){ var p=day.getAttribute('data-date').split('-'); var d=new Date(+p[0],+p[1]-1,+p[2]);
      if(!st.start||st.end){ st.start=d; st.end=null; } else { if(d<st.start){ st.end=st.start; st.start=d; } else st.end=d; }
      render(); }
  });
  document.addEventListener('click',function(ev){ if(st.open && !container.contains(ev.target) && ev.target!==toggle && !toggle.contains(ev.target)) open(false); });
}
caCal(document.getElementById("ca-cal"), document.getElementById("ca-range-toggle"));
/* botão reload: busca novos carrinhos a partir da data do último cache (incremental) */
(function(){ var rb=document.getElementById("ca-reload"); if(!rb) return;
  rb.addEventListener("click",function(){ if(rb.classList.contains("is-spin")) return;
    rb.classList.add("is-spin"); load(true);
    setTimeout(function(){ rb.classList.remove("is-spin"); },1200);
  });
})();

/* carrega estados em paralelo; load() não espera recovered (endpoint pode não existir ainda) */
loadRecovered(function(){});
loadConverted(function(){});
loadCoupons(function(){});
loadConvOrders(function(){ if(_tab==="convertidos") render(); });
/* restaura o último período usado (senão o padrão 7d): abre já no mesmo range,
   pintando instantaneamente do cache e mantendo Contatados/Convertidos populados */
try{ var _sr=JSON.parse(localStorage.getItem('mc_cart_range')||'null');
  if(_sr&&_sr.r){ range=_sr.r; var _lbl=document.getElementById('ca-range-label'); if(_lbl&&_sr.label) _lbl.textContent=_sr.label; }
}catch(e){}
loadContacts(function(){ if(caHasAnyCache()) load(); else bootstrapCarts(); });
})();